var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 472.204,
    height: 456.142,
    viewBox: "0 0 472.204 456.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loginHero",
    transform: "translate(-11.391 -33.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8500",
    "data-name": "Group 8500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8493",
    "data-name": "Group 8493"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1062",
    "data-name": "Ellipse 1062",
    cx: 95.184,
    cy: 17.36,
    rx: 95.184,
    ry: 17.36,
    transform: "translate(175.182 444.979)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8495",
    "data-name": "Group 8495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8494",
    "data-name": "Group 8494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5943",
    "data-name": "Path 5943",
    d: "M346.36,461.351a2.537,2.537,0,0,0-.212-.778,4.448,4.448,0,0,0-1.665-1.658,30.277,30.277,0,0,0-8.6-3.178c-7.774-1.924-19.3-3.485-33.582-4.46a501.836,501.836,0,0,0-50.285-.728c-9.46.34-19.388.939-29.62,2.107-5.113.6-10.307,1.325-15.509,2.4a67.642,67.642,0,0,0-7.743,2.028,23.181,23.181,0,0,0-3.692,1.564,8.243,8.243,0,0,0-1.616,1.126,1.89,1.89,0,0,0-.01,3.147,8.142,8.142,0,0,0,1.614,1.129,23.062,23.062,0,0,0,3.692,1.566,67.323,67.323,0,0,0,7.745,2.031c5.2,1.074,10.4,1.8,15.513,2.4,10.235,1.169,20.165,1.767,29.626,2.107a501.312,501.312,0,0,0,50.289-.728c14.285-.975,25.807-2.536,33.579-4.46a30.254,30.254,0,0,0,8.6-3.178,4.441,4.441,0,0,0,1.665-1.658,2.537,2.537,0,0,0,.212-.778,1.562,1.562,0,0,1-.164.8,4.408,4.408,0,0,1-1.655,1.724,29.682,29.682,0,0,1-8.606,3.287c-7.779,1.989-19.308,3.607-33.6,4.63a492.648,492.648,0,0,1-50.331.841c-9.472-.327-19.413-.916-29.668-2.08-5.125-.6-10.332-1.323-15.56-2.4a67.583,67.583,0,0,1-7.807-2.046,23.488,23.488,0,0,1-3.778-1.6,8.694,8.694,0,0,1-1.72-1.206,2.4,2.4,0,0,1,.012-3.9,8.7,8.7,0,0,1,1.721-1.2,23.643,23.643,0,0,1,3.777-1.6,67.938,67.938,0,0,1,7.805-2.044c5.226-1.076,10.432-1.8,15.556-2.4,10.252-1.163,20.192-1.752,29.662-2.08a492.87,492.87,0,0,1,50.327.841c14.3,1.023,25.826,2.641,33.605,4.63a29.711,29.711,0,0,1,8.608,3.287,4.408,4.408,0,0,1,1.655,1.724A1.562,1.562,0,0,1,346.36,461.351Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8497",
    "data-name": "Group 8497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8496",
    "data-name": "Group 8496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5944",
    "data-name": "Path 5944",
    d: "M319.005,460.555a3.335,3.335,0,0,0-.153-.486,2.718,2.718,0,0,0-1.053-1.038,19.1,19.1,0,0,0-5.441-1.993,132.9,132.9,0,0,0-21.256-2.794c-9.044-.6-19.851-.856-31.83-.439-5.987.22-12.271.594-18.745,1.339-3.236.377-6.522.837-9.81,1.52a43.237,43.237,0,0,0-4.892,1.28,14.559,14.559,0,0,0-2.322.983c-.705.387-1.47.941-1.514,1.624.038.684.8,1.24,1.507,1.628a14.755,14.755,0,0,0,2.322.985,43.455,43.455,0,0,0,4.892,1.281c3.289.683,6.577,1.143,9.813,1.52,6.476.745,12.761,1.12,18.749,1.34,11.981.416,22.788.157,31.832-.44a132.728,132.728,0,0,0,21.255-2.794,19.1,19.1,0,0,0,5.441-1.993,2.721,2.721,0,0,0,1.052-1.038,3.4,3.4,0,0,0,.153-.485,1.21,1.21,0,0,1-.105.507,2.682,2.682,0,0,1-1.042,1.1,18.551,18.551,0,0,1-5.449,2.1,127.9,127.9,0,0,1-21.279,2.965,310.724,310.724,0,0,1-31.874.551c-6-.207-12.3-.572-18.791-1.312-3.247-.375-6.547-.834-9.86-1.52a43.761,43.761,0,0,1-4.955-1.3,15.168,15.168,0,0,1-2.407-1.022,6.151,6.151,0,0,1-1.11-.776,1.609,1.609,0,0,1,.008-2.612,6.06,6.06,0,0,1,1.11-.775,15.25,15.25,0,0,1,2.407-1.02,43.936,43.936,0,0,1,4.953-1.295c3.313-.685,6.611-1.144,9.857-1.519,6.495-.74,12.79-1.1,18.788-1.311a310.382,310.382,0,0,1,31.871.551,127.821,127.821,0,0,1,21.281,2.965,18.5,18.5,0,0,1,5.45,2.1,2.687,2.687,0,0,1,1.042,1.1A1.213,1.213,0,0,1,319.005,460.555Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8499",
    "data-name": "Group 8499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8498",
    "data-name": "Group 8498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5945",
    "data-name": "Path 5945",
    d: "M296.912,460.548a1.137,1.137,0,0,0-.617-.74,9.73,9.73,0,0,0-2.718-.969,67.744,67.744,0,0,0-10.622-1.354c-4.52-.287-9.92-.407-15.9-.192-2.991.113-6.13.3-9.362.676-1.615.189-3.255.42-4.893.76a21.642,21.642,0,0,0-2.43.636,7.185,7.185,0,0,0-1.14.483c-.348.182-.688.469-.69.7s.337.517.686.7a7.317,7.317,0,0,0,1.14.482,21.5,21.5,0,0,0,2.431.637c1.638.341,3.279.571,4.894.761,3.233.373,6.373.563,9.364.676,5.986.215,11.386.1,15.906-.192a67.7,67.7,0,0,0,10.621-1.354,9.717,9.717,0,0,0,2.718-.969,1.137,1.137,0,0,0,.617-.74.454.454,0,0,1-.04.259,1.334,1.334,0,0,1-.518.568,9.127,9.127,0,0,1-2.727,1.079,62.849,62.849,0,0,1-10.646,1.525,153.276,153.276,0,0,1-15.947.3c-3-.1-6.153-.281-9.406-.65-1.626-.187-3.279-.416-4.942-.76a21.8,21.8,0,0,1-2.493-.652,7.552,7.552,0,0,1-1.225-.52c-.365-.228-.879-.476-.954-1.156.081-.679.593-.924.958-1.153a7.823,7.823,0,0,1,1.225-.519,21.991,21.991,0,0,1,2.492-.651c1.663-.344,3.315-.573,4.941-.76,3.252-.368,6.4-.548,9.4-.648a153,153,0,0,1,15.946.3,62.746,62.746,0,0,1,10.646,1.525,9.1,9.1,0,0,1,2.727,1.079,1.325,1.325,0,0,1,.519.568A.454.454,0,0,1,296.912,460.548Z",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8506",
    "data-name": "Group 8506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8502",
    "data-name": "Group 8502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8501",
    "data-name": "Group 8501"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 30.196,
    height: 11.939,
    transform: "translate(30.704 129.372)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8505",
    "data-name": "Group 8505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8504",
    "data-name": "Group 8504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8503",
    "data-name": "Group 8503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5946",
    "data-name": "Path 5946",
    d: "M48.838,153.073a1.676,1.676,0,0,1-.012-.217c0-.16-.007-.361-.012-.613q-.01-.841-.028-2.349c-.015-2.061-.037-5.025-.064-8.761l.116.14-37.255.09c.084-.1-.192.23.187-.229v3.053q0,1.518,0,3.013,0,2.989,0,5.873l-.185-.225,26.55.1,7.837.064,2.119.03.554.014a1.108,1.108,0,0,1,.2.015.742.742,0,0,1-.173.014l-.531.015-2.079.029-7.8.064-26.679.1H11.4v-.225q0-2.88,0-5.873,0-1.494,0-3.013v-3.053c.379-.461.106-.128.192-.231l37.255.09h.116v.139c-.027,3.772-.049,6.763-.064,8.844q-.018,1.486-.028,2.318c-.005.241-.009.435-.012.588A1.276,1.276,0,0,1,48.838,153.073Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8512",
    "data-name": "Group 8512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8508",
    "data-name": "Group 8508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8507",
    "data-name": "Group 8507"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 48.653,
    height: 12.871,
    transform: "translate(293.652 391.607)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8511",
    "data-name": "Group 8511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8510",
    "data-name": "Group 8510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8509",
    "data-name": "Group 8509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5947",
    "data-name": "Path 5947",
    d: "M321.732,418.035a1.536,1.536,0,0,1-.015-.234l-.016-.66q-.014-.907-.036-2.533c-.02-2.222-.048-5.416-.084-9.443l.151.15-48.65.1c.11-.11-.25.247.245-.247v3.291q0,1.637,0,3.248,0,3.223,0,6.331l-.243-.242,34.672.11,10.233.069,2.768.032.724.016a1.849,1.849,0,0,1,.256.015,1,1,0,0,1-.225.016l-.694.016-2.715.032-10.178.069-34.841.11h-.242v-.244q0-3.1,0-6.331,0-1.611,0-3.248v-3.291c.5-.5.14-.138.251-.249l48.65.1h.152v.151c-.036,4.065-.064,7.29-.084,9.533q-.023,1.6-.036,2.5c-.007.26-.012.469-.016.634A.946.946,0,0,1,321.732,418.035Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8521",
    "data-name": "Group 8521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8514",
    "data-name": "Group 8514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8513",
    "data-name": "Group 8513"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 48.653,
    height: 12.871,
    transform: "translate(203.365 133.891)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8517",
    "data-name": "Group 8517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8516",
    "data-name": "Group 8516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8515",
    "data-name": "Group 8515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5948",
    "data-name": "Path 5948",
    d: "M231.445,160.319a1.554,1.554,0,0,1-.015-.234l-.016-.66q-.014-.907-.036-2.533c-.02-2.222-.048-5.416-.084-9.444l.151.151-48.65.1c.11-.11-.25.247.245-.247v3.291q0,1.636,0,3.248,0,3.223,0,6.331l-.243-.242,34.672.11,10.233.069,2.768.032.724.016a1.852,1.852,0,0,1,.256.015,1,1,0,0,1-.225.016l-.694.016-2.715.031-10.178.07-34.841.11h-.242v-.243q0-3.105,0-6.331,0-1.611,0-3.248v-3.291c.5-.5.14-.138.251-.249l48.65.1h.152v.15c-.036,4.066-.064,7.291-.084,9.534q-.022,1.6-.036,2.5c-.007.26-.012.469-.016.634A.948.948,0,0,1,231.445,160.319Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8520",
    "data-name": "Group 8520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8519",
    "data-name": "Group 8519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8518",
    "data-name": "Group 8518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5949",
    "data-name": "Path 5949",
    d: "M346.715,46.3a1.552,1.552,0,0,1-.015-.234l-.016-.66q-.014-.909-.036-2.533c-.02-2.222-.048-5.417-.084-9.444l.151.15-48.65.1c.11-.111-.25.247.245-.248v3.292q0,1.636,0,3.248,0,3.222,0,6.331l-.243-.243,34.672.111,10.234.069,2.767.031.724.016a1.58,1.58,0,0,1,.256.016,1.194,1.194,0,0,1-.225.016l-.694.015-2.715.032-10.178.069-34.841.11h-.242V46.3q0-3.1,0-6.331,0-1.611,0-3.248V33.425c.5-.5.14-.137.251-.248l48.65.1h.152v.151c-.036,4.066-.064,7.29-.084,9.533q-.023,1.6-.036,2.5c-.007.26-.012.468-.016.633A.951.951,0,0,1,346.715,46.3Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8527",
    "data-name": "Group 8527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8523",
    "data-name": "Group 8523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8522",
    "data-name": "Group 8522"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 48.653,
    height: 12.871,
    transform: "translate(431.403 194.063)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8526",
    "data-name": "Group 8526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8525",
    "data-name": "Group 8525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8524",
    "data-name": "Group 8524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5950",
    "data-name": "Path 5950",
    d: "M467,220.491a1.533,1.533,0,0,1-.015-.233l-.016-.661q-.013-.907-.037-2.533c-.019-2.222-.048-5.416-.083-9.443l.151.15-48.65.1c.11-.11-.25.247.245-.247v3.291q0,1.637,0,3.248,0,3.224,0,6.331l-.242-.242,34.671.11,10.234.069,2.768.032.723.016a1.877,1.877,0,0,1,.257.015,1.007,1.007,0,0,1-.226.016l-.694.016-2.715.032-10.178.069-34.84.11h-.242v-.244q0-3.1-.005-6.331,0-1.611,0-3.248v-3.291c.5-.5.139-.138.251-.248l48.65.1h.152v.151c-.036,4.065-.064,7.29-.084,9.533q-.023,1.6-.036,2.5c-.007.26-.012.469-.016.634A.934.934,0,0,1,467,220.491Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8539",
    "data-name": "Group 8539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8529",
    "data-name": "Group 8529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8528",
    "data-name": "Group 8528"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 90.773,
    height: 150.256,
    transform: "translate(81.05 60.214)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8531",
    "data-name": "Group 8531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8530",
    "data-name": "Group 8530"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 90.773,
    height: 150.256,
    transform: "translate(78.031 60.214)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8533",
    "data-name": "Group 8533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8532",
    "data-name": "Group 8532"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 83.043,
    height: 144.162,
    transform: "translate(81.896 63.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8538",
    "data-name": "Group 8538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8535",
    "data-name": "Group 8535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8534",
    "data-name": "Group 8534"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 51.064,
    height: 106.696,
    transform: "translate(97.706 81.994)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8537",
    "data-name": "Group 8537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8536",
    "data-name": "Group 8536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5951",
    "data-name": "Path 5951",
    d: "M97.706,150.934c-.119-9.967,8.843-19.7,18.713-21.088,4.706-.664,9.707.27,14.1-1.533,7.85-3.219,10.347-13.648,18.247-16.741l.36,77.118H97.706Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8546",
    "data-name": "Group 8546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8542",
    "data-name": "Group 8542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8541",
    "data-name": "Group 8541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8540",
    "data-name": "Group 8540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5952",
    "data-name": "Path 5952",
    d: "M476.07,118.332a1.8,1.8,0,0,1-.016-.26c0-.191-.011-.432-.018-.733q-.015-1.008-.04-2.813c-.022-2.467-.054-6.014-.093-10.486l.167.168-54.018.108c.122-.123-.278.274.272-.275V107.7l0,3.606q0,3.577,0,7.03l-.269-.27,38.5.123,11.363.077,3.073.035.8.017a1.891,1.891,0,0,1,.284.018,1.248,1.248,0,0,1-.25.017l-.77.017-3.015.036-11.3.077-38.685.122h-.269v-.27q0-3.447,0-7.03,0-1.79,0-3.606,0-.909,0-1.823v-1.832c.551-.551.155-.153.279-.276l54.018.108h.169v.167c-.04,4.515-.071,8.1-.093,10.586q-.025,1.779-.04,2.775c-.008.289-.013.52-.018.7A1.041,1.041,0,0,1,476.07,118.332Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8545",
    "data-name": "Group 8545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8544",
    "data-name": "Group 8544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8543",
    "data-name": "Group 8543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5953",
    "data-name": "Path 5953",
    d: "M483.395,104.04a1.547,1.547,0,0,1-.021-.272c-.005-.2-.013-.453-.021-.757q-.018-1.055-.049-2.865c-.026-2.506-.062-6.045-.107-10.4l.2.2-32.456.077c-.247.246.332-.335.273-.274v1.87q0,.931,0,1.853,0,1.844,0,3.638c0,2.39-.007,4.709-.01,6.929l-.262-.262,23.219.125,6.763.072,1.824.033a5.862,5.862,0,0,1,.652.032,3.711,3.711,0,0,1-.589.033l-1.77.033-6.7.072-23.4.124-.262,0v-.264c0-2.22-.007-4.539-.01-6.929q0-1.794,0-3.638V89.75c-.06.059.523-.522.278-.276l32.456.077h.2l0,.2c-.045,4.4-.081,7.982-.107,10.517q-.03,1.782-.049,2.821A8.061,8.061,0,0,1,483.395,104.04Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8548",
    "data-name": "Group 8548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8547",
    "data-name": "Group 8547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5954",
    "data-name": "Path 5954",
    d: "M467.537,435.018c0,.144-96.955.261-216.527.261-119.613,0-216.547-.117-216.547-.261s96.934-.26,216.547-.26C370.582,434.758,467.537,434.875,467.537,435.018Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8660",
    "data-name": "Group 8660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8603",
    "data-name": "Group 8603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8602",
    "data-name": "Group 8602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8589",
    "data-name": "Group 8589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8588",
    "data-name": "Group 8588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8583",
    "data-name": "Group 8583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8582",
    "data-name": "Group 8582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8581",
    "data-name": "Group 8581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8580",
    "data-name": "Group 8580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8579",
    "data-name": "Group 8579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8566",
    "data-name": "Group 8566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8565",
    "data-name": "Group 8565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8564",
    "data-name": "Group 8564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8563",
    "data-name": "Group 8563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8562",
    "data-name": "Group 8562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8561",
    "data-name": "Group 8561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8560",
    "data-name": "Group 8560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8553",
    "data-name": "Group 8553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8552",
    "data-name": "Group 8552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8551",
    "data-name": "Group 8551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8550",
    "data-name": "Group 8550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8549",
    "data-name": "Group 8549"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 235.107,
    height: 337.399,
    rx: 10.493,
    transform: "translate(204.148 38.169)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8559",
    "data-name": "Group 8559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8558",
    "data-name": "Group 8558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8557",
    "data-name": "Group 8557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8556",
    "data-name": "Group 8556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8555",
    "data-name": "Group 8555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8554",
    "data-name": "Group 8554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5955",
    "data-name": "Path 5955",
    d: "M428.762,375.568s.246-.02.731-.049a6.19,6.19,0,0,0,.9-.109,8.586,8.586,0,0,0,1.233-.273,10.5,10.5,0,0,0,6.4-5.246A10.907,10.907,0,0,0,439,367.1a16.665,16.665,0,0,0,.194-3.288q0-3.474-.011-7.594c-.006-5.488-.014-11.821-.022-18.949-.018-28.519-.043-69.779-.075-120.762-.009-25.494-.019-53.417-.029-83.394q-.006-22.482-.012-46.457,0-11.976-.005-24.3,0-6.157,0-12.4a16.276,16.276,0,0,0-.165-3.078,9.937,9.937,0,0,0-.969-2.9,10.426,10.426,0,0,0-4.24-4.355,11.2,11.2,0,0,0-2.9-1.045,15.714,15.714,0,0,0-3.119-.2h-6.378l-12.87,0-26.18,0-54,.006-113.548,0a10.248,10.248,0,0,0-10.1,8.353,18.332,18.332,0,0,0-.184,3.568V61.159q0,14.409,0,28.621,0,28.419,0,55.958c0,36.687-.009,72.074-.013,105.784s-.015,65.744-.022,95.723q0,5.621,0,11.145,0,2.761,0,5.5a17.047,17.047,0,0,0,.122,2.7,10.227,10.227,0,0,0,8.743,8.685,17.532,17.532,0,0,0,2.622.113h2.642l5.245,0,40.015.015,120.756.075,32.831.045,8.538.023c1.923.008,2.909.024,2.909.024s-.986.016-2.909.024l-8.538.024-32.831.044-120.756.075-40.015.016-5.245,0h-2.642a18.112,18.112,0,0,1-2.674-.114,10.6,10.6,0,0,1-9.068-9,17.427,17.427,0,0,1-.127-2.751q0-2.738,0-5.5,0-5.525,0-11.145c-.007-29.979-.015-62.013-.022-95.723s-.009-69.1-.014-105.784q0-27.515,0-55.958,0-14.209,0-28.621V50.326a18.79,18.79,0,0,1,.192-3.655,10.72,10.72,0,0,1,10.565-8.739l113.548.005,54,.006,26.18,0,12.87,0h6.378a16.107,16.107,0,0,1,3.2.206,11.64,11.64,0,0,1,3.028,1.091,10.861,10.861,0,0,1,4.418,4.54,10.42,10.42,0,0,1,1.01,3.022,16.776,16.776,0,0,1,.17,3.153q0,6.24,0,12.4,0,12.316,0,24.3-.006,23.951-.012,46.457c-.01,29.977-.02,57.9-.029,83.394-.031,50.983-.057,92.243-.075,120.762-.008,7.128-.015,13.461-.021,18.949q-.007,4.116-.012,7.594a16.693,16.693,0,0,1-.208,3.309,10.968,10.968,0,0,1-1,2.814,10.535,10.535,0,0,1-6.47,5.249,8.517,8.517,0,0,1-1.24.262,5.889,5.889,0,0,1-.9.1C429.008,375.564,428.762,375.568,428.762,375.568Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8578",
    "data-name": "Group 8578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8577",
    "data-name": "Group 8577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8576",
    "data-name": "Group 8576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8575",
    "data-name": "Group 8575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8574",
    "data-name": "Group 8574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8573",
    "data-name": "Group 8573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8572",
    "data-name": "Group 8572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8571",
    "data-name": "Group 8571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8570",
    "data-name": "Group 8570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8569",
    "data-name": "Group 8569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8568",
    "data-name": "Group 8568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8567",
    "data-name": "Group 8567"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1063",
    "data-name": "Ellipse 1063",
    cx: 9.021,
    cy: 9.021,
    r: 9.021,
    transform: "translate(308.944 358.613) rotate(-45)",
    fill: "#455a64"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8587",
    "data-name": "Group 8587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8586",
    "data-name": "Group 8586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8585",
    "data-name": "Group 8585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8584",
    "data-name": "Group 8584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5956",
    "data-name": "Path 5956",
    d: "M345.79,56H297.774a3.349,3.349,0,0,1-3.349-3.348h0a3.349,3.349,0,0,1,3.349-3.349H345.79a3.348,3.348,0,0,1,3.349,3.349h0A3.348,3.348,0,0,1,345.79,56Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8601",
    "data-name": "Group 8601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8600",
    "data-name": "Group 8600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8599",
    "data-name": "Group 8599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8598",
    "data-name": "Group 8598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8597",
    "data-name": "Group 8597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8596",
    "data-name": "Group 8596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8595",
    "data-name": "Group 8595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8594",
    "data-name": "Group 8594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8593",
    "data-name": "Group 8593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8592",
    "data-name": "Group 8592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8591",
    "data-name": "Group 8591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8590",
    "data-name": "Group 8590"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 220.28,
    height: 281.769,
    transform: "translate(211.358 62.24)",
    fill: "#fff"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8652",
    "data-name": "Group 8652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8624",
    "data-name": "Group 8624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8607",
    "data-name": "Group 8607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8604",
    "data-name": "Group 8604"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 148.822,
    height: 25.708,
    rx: 1.454,
    transform: "translate(247.124 195.363)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8606",
    "data-name": "Group 8606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8605",
    "data-name": "Group 8605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5957",
    "data-name": "Path 5957",
    d: "M394.492,221.071a1.626,1.626,0,0,0,.823-.289,1.436,1.436,0,0,0,.564-.887c.051-.42.006-.942.014-1.515-.011-2.322-.027-5.722-.048-10.1-.007-2.194-.015-4.631-.023-7.3q-.006-2-.011-4.172a1.322,1.322,0,0,0-1.259-1.307h-2.288l-21.159.039-122.518.076a1.2,1.2,0,0,0-1.2,1.151l0,2.224v4.446q0,4.431,0,8.8,0,2.186,0,4.354v2.164c.007.342-.016.76.016,1.038a1.191,1.191,0,0,0,.433.749,1.209,1.209,0,0,0,.84.264h7.46l32.53.015,55.081.056,37.134.083,10.1.049,2.626.026c.592.008.9.026.9.026s-.3.018-.9.027l-2.626.026-10.1.049-37.134.082-55.081.056-32.53.015-4.25,0h-3.21a1.74,1.74,0,0,1-1.163-.376,1.72,1.72,0,0,1-.62-1.072c-.044-.436-.012-.74-.022-1.117V216.6q0-2.169,0-4.354,0-4.369,0-8.8V199l0-2.242a1.723,1.723,0,0,1,1.72-1.654l122.518.077,21.159.038,2.3.009a1.6,1.6,0,0,1,1.516,1.587q-.006,2.17-.011,4.173c-.008,2.666-.016,5.1-.023,7.3-.021,4.375-.037,7.775-.049,10.1-.017.58.021,1.08-.042,1.53a1.477,1.477,0,0,1-.61.915,1.412,1.412,0,0,1-.628.24A.857.857,0,0,1,394.492,221.071Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8611",
    "data-name": "Group 8611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8608",
    "data-name": "Group 8608"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 148.822,
    height: 25.708,
    rx: 1.454,
    transform: "translate(247.27 230.67)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8610",
    "data-name": "Group 8610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8609",
    "data-name": "Group 8609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5958",
    "data-name": "Path 5958",
    d: "M394.637,256.379a1.637,1.637,0,0,0,.824-.289,1.441,1.441,0,0,0,.564-.888c.05-.419.006-.941.014-1.514-.011-2.323-.027-5.723-.049-10.1-.006-2.193-.014-4.63-.022-7.3q-.006-2-.011-4.172a1.323,1.323,0,0,0-1.259-1.307l-2.288,0-21.159.039-122.518.076a1.2,1.2,0,0,0-1.2,1.151l0,2.224v4.445q0,4.431,0,8.8,0,2.184,0,4.353v2.164c.007.342-.016.76.016,1.039a1.193,1.193,0,0,0,.432.749,1.223,1.223,0,0,0,.841.264h3.21l4.249,0,32.53.015,55.082.056,37.133.082,10.1.049,2.626.026c.591.009.894.027.894.027s-.3.018-.894.026l-2.626.026-10.1.049-37.133.083-55.082.056-32.53.015h-7.459a1.741,1.741,0,0,1-1.163-.377,1.713,1.713,0,0,1-.62-1.071c-.044-.436-.012-.741-.022-1.118v-2.164q0-2.169,0-4.353,0-4.369,0-8.8v-4.445l0-2.242a1.722,1.722,0,0,1,1.721-1.654l122.518.076,21.159.039,2.3.009a1.6,1.6,0,0,1,1.516,1.587q-.006,2.17-.011,4.172c-.008,2.667-.016,5.1-.023,7.3-.021,4.375-.038,7.775-.049,10.1-.017.579.021,1.079-.042,1.53a1.483,1.483,0,0,1-.61.915,1.425,1.425,0,0,1-.628.24A.866.866,0,0,1,394.637,256.379Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8612",
    "data-name": "Group 8612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5959",
    "data-name": "Path 5959",
    d: "M262.479,204.667v5.939h-.7l-3.564-4.429v4.429h-.848v-5.939h.7l3.562,4.429v-4.429Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5960",
    "data-name": "Path 5960",
    d: "M267.709,207.891v2.715h-.772v-.594a1.669,1.669,0,0,1-1.476.645c-1.018,0-1.664-.543-1.664-1.324,0-.721.467-1.315,1.808-1.315h1.289v-.161c0-.687-.4-1.086-1.2-1.086a2.275,2.275,0,0,0-1.426.484l-.339-.611a2.991,2.991,0,0,1,1.858-.577C267.013,206.067,267.709,206.661,267.709,207.891Zm-.815,1.34V208.6h-1.255c-.806,0-1.035.313-1.035.695,0,.45.373.73.992.73A1.3,1.3,0,0,0,266.894,209.231Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5961",
    "data-name": "Path 5961",
    d: "M276.688,208.018v2.588h-.814v-2.494c0-.883-.425-1.315-1.163-1.315a1.305,1.305,0,0,0-1.349,1.493v2.316h-.815v-2.494c0-.883-.423-1.315-1.162-1.315a1.3,1.3,0,0,0-1.348,1.493v2.316h-.815v-4.5H270v.671a1.822,1.822,0,0,1,1.552-.713,1.664,1.664,0,0,1,1.561.831,2.03,2.03,0,0,1,1.73-.831A1.724,1.724,0,0,1,276.688,208.018Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5962",
    "data-name": "Path 5962",
    d: "M282.267,208.629h-3.648a1.522,1.522,0,0,0,1.629,1.315,1.678,1.678,0,0,0,1.3-.543l.451.526a2.451,2.451,0,0,1-4.192-1.569,2.2,2.2,0,0,1,2.257-2.291,2.168,2.168,0,0,1,2.223,2.316C282.284,208.451,282.275,208.553,282.267,208.629Zm-3.648-.585H281.5a1.452,1.452,0,0,0-2.885,0Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8613",
    "data-name": "Group 8613"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 148.822,
    height: 25.708,
    rx: 1.454,
    transform: "translate(247.503 270.489)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8614",
    "data-name": "Group 8614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5963",
    "data-name": "Path 5963",
    d: "M308.475,280.563h1.683v4.615H313v1.334h-4.522Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5964",
    "data-name": "Path 5964",
    d: "M313.273,284.2a2.61,2.61,0,1,1,2.6,2.387A2.407,2.407,0,0,1,313.273,284.2Zm3.569,0a.975.975,0,1,0-1.937,0,.977.977,0,1,0,1.937,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5965",
    "data-name": "Path 5965",
    d: "M324.173,281.906v3.764c0,1.743-.986,2.568-2.7,2.568a4.053,4.053,0,0,1-2.286-.6l.587-1.131a2.659,2.659,0,0,0,1.555.493c.867,0,1.232-.39,1.232-1.113v-.153a1.716,1.716,0,0,1-1.368.544,2.223,2.223,0,1,1,0-4.445,1.672,1.672,0,0,1,1.445.637v-.56Zm-1.6,2.141a1.01,1.01,0,0,0-2.015,0,1.01,1.01,0,0,0,2.015,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5966",
    "data-name": "Path 5966",
    d: "M327.754,280.563h1.682v5.949h-1.682Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5967",
    "data-name": "Path 5967",
    d: "M335.461,283.877v2.635h-1.616v-2.371c0-.663-.289-.943-.757-.943-.517,0-.918.322-.918,1.087v2.227h-1.614v-4.606h1.538v.5a1.982,1.982,0,0,1,1.462-.578A1.8,1.8,0,0,1,335.461,283.877Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8615",
    "data-name": "Group 8615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5968",
    "data-name": "Path 5968",
    d: "M258.863,243.68a2.237,2.237,0,1,1-2.237-2.237A2.238,2.238,0,0,1,258.863,243.68Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8616",
    "data-name": "Group 8616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5969",
    "data-name": "Path 5969",
    d: "M265.9,243.68a2.237,2.237,0,1,1-2.238-2.237A2.238,2.238,0,0,1,265.9,243.68Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8617",
    "data-name": "Group 8617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5970",
    "data-name": "Path 5970",
    d: "M272.934,243.68a2.237,2.237,0,1,1-2.237-2.237A2.237,2.237,0,0,1,272.934,243.68Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8618",
    "data-name": "Group 8618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5971",
    "data-name": "Path 5971",
    d: "M279.97,243.68a2.237,2.237,0,1,1-2.237-2.237A2.238,2.238,0,0,1,279.97,243.68Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8619",
    "data-name": "Group 8619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5972",
    "data-name": "Path 5972",
    d: "M287.006,243.68a2.238,2.238,0,1,1-2.237-2.237A2.238,2.238,0,0,1,287.006,243.68Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8620",
    "data-name": "Group 8620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5973",
    "data-name": "Path 5973",
    d: "M294.042,243.68a2.238,2.238,0,1,1-2.238-2.237A2.238,2.238,0,0,1,294.042,243.68Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8621",
    "data-name": "Group 8621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5974",
    "data-name": "Path 5974",
    d: "M301.077,243.68a2.237,2.237,0,1,1-2.237-2.237A2.237,2.237,0,0,1,301.077,243.68Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8622",
    "data-name": "Group 8622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5975",
    "data-name": "Path 5975",
    d: "M308.113,243.68a2.237,2.237,0,1,1-2.237-2.237A2.238,2.238,0,0,1,308.113,243.68Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8623",
    "data-name": "Group 8623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5976",
    "data-name": "Path 5976",
    d: "M384.493,242.045h-.581v-.817a2.772,2.772,0,1,0-5.544,0v.817h-.841a1.023,1.023,0,0,0-1.022,1.023v4.5a1.022,1.022,0,0,0,1.022,1.022h6.966a1.022,1.022,0,0,0,1.022-1.022v-4.5A1.023,1.023,0,0,0,384.493,242.045Zm-2.424,5.082h-2.111l.547-1.375a1.153,1.153,0,1,1,1,.006Zm1-5.082H379.21v-.817a1.93,1.93,0,0,1,3.859,0Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8638",
    "data-name": "Group 8638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8628",
    "data-name": "Group 8628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8625",
    "data-name": "Group 8625"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1064",
    "data-name": "Ellipse 1064",
    cx: 44.481,
    cy: 44.481,
    r: 44.481,
    transform: "translate(277.433 92.781)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8627",
    "data-name": "Group 8627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8626",
    "data-name": "Group 8626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5977",
    "data-name": "Path 5977",
    d: "M366.395,137.262s-.031-.244-.063-.72c-.031-.493-.075-1.2-.133-2.112q-.041-.7-.091-1.555c-.059-.569-.181-1.186-.28-1.858s-.221-1.394-.343-2.165a23.913,23.913,0,0,0-.58-2.426,42.366,42.366,0,0,0-4.923-11.8,44.192,44.192,0,0,0-11.267-12.57l-1.915-1.427c-.673-.441-1.382-.845-2.082-1.277-.716-.407-1.393-.9-2.16-1.249l-2.3-1.1-1.169-.554L337.862,96l-2.492-.908c-.846-.28-1.732-.46-2.608-.7a22.519,22.519,0,0,0-2.679-.606,41.151,41.151,0,0,0-5.6-.648c-.954-.033-1.916-.126-2.885-.111l-2.928.151c-.491.034-.987.031-1.478.1l-1.476.227c-.985.163-1.986.278-2.977.483a46.64,46.64,0,0,0-5.9,1.731,46.03,46.03,0,0,0-5.769,2.535c-.934.507-1.83,1.1-2.755,1.645-.453.29-.936.537-1.367.864l-1.3.975a49.926,49.926,0,0,0-5.018,4.264q-1.117,1.233-2.248,2.477l-.565.622-.508.672-1.013,1.356-1.017,1.36-.89,1.456-.89,1.464-.446.735-.378.773q-.747,1.554-1.5,3.119-.6,1.632-1.2,3.275a43.834,43.834,0,0,0,0,27.909q.6,1.644,1.2,3.276l1.5,3.12.378.774.446.735.889,1.465.891,1.456L286.3,163.4l1.013,1.355.508.673.565.623,2.249,2.476a49.691,49.691,0,0,0,5.018,4.266l1.3.975c.431.328.914.575,1.367.864.925.549,1.821,1.139,2.755,1.646a46.05,46.05,0,0,0,5.77,2.536,46.871,46.871,0,0,0,5.9,1.731c.991.2,1.992.32,2.977.483l1.476.227c.491.065.988.062,1.478.1l2.929.151c.969.015,1.931-.078,2.885-.112a41.007,41.007,0,0,0,5.6-.648,22.326,22.326,0,0,0,2.679-.607c.876-.238,1.762-.418,2.608-.7l2.492-.908,1.228-.447,1.169-.555,2.3-1.1c.767-.348,1.444-.842,2.159-1.249.7-.432,1.41-.836,2.082-1.277l1.915-1.427A44.2,44.2,0,0,0,359.984,159.9a42.416,42.416,0,0,0,4.922-11.8,24.219,24.219,0,0,0,.579-2.425q.183-1.158.343-2.165c.1-.672.221-1.289.28-1.858q.051-.856.091-1.555.087-1.374.133-2.111c.032-.476.063-.72.063-.72s.005.244-.01.72q-.029.741-.081,2.117-.03.7-.066,1.561c-.052.572-.165,1.192-.257,1.867s-.206,1.4-.32,2.177a23.641,23.641,0,0,1-.559,2.441,42.2,42.2,0,0,1-4.868,11.9,44.335,44.335,0,0,1-11.293,12.715l-1.926,1.445c-.677.448-1.39.858-2.1,1.3-.719.413-1.4.913-2.174,1.267l-2.316,1.12-1.179.563-1.238.456-2.512.923c-.854.286-1.747.47-2.631.713a22.722,22.722,0,0,1-2.7.62,41.592,41.592,0,0,1-5.65.668c-.964.036-1.935.131-2.914.119l-2.959-.147c-.5-.033-1-.029-1.494-.094l-1.491-.226c-1-.162-2.008-.278-3.01-.483a47.252,47.252,0,0,1-5.967-1.739,46.534,46.534,0,0,1-5.837-2.556c-.945-.511-1.852-1.106-2.788-1.66-.458-.292-.947-.542-1.383-.872l-1.319-.984a50.191,50.191,0,0,1-5.079-4.309L288,166.38l-.572-.629-.514-.68-1.026-1.37-1.03-1.376-.9-1.472-.9-1.482-.452-.743-.383-.782L280.7,154.69q-.6-1.651-1.215-3.315a44.286,44.286,0,0,1,0-28.235l1.216-3.313,1.52-3.155.384-.782.451-.743.9-1.482.9-1.471,1.029-1.376,1.025-1.369.515-.68.572-.629,2.277-2.5a50.157,50.157,0,0,1,5.078-4.307l1.318-.985c.436-.329.925-.579,1.383-.872.936-.554,1.843-1.148,2.788-1.659a46.3,46.3,0,0,1,5.836-2.555,47.2,47.2,0,0,1,5.967-1.739c1-.206,2.013-.321,3.009-.484l1.491-.226c.5-.064,1-.06,1.494-.094l2.958-.146c.979-.013,1.95.083,2.914.118a41.608,41.608,0,0,1,5.65.668,22.751,22.751,0,0,1,2.7.62c.884.242,1.778.427,2.631.712l2.513.924,1.237.455,1.179.563,2.316,1.12c.772.353,1.455.854,2.175,1.267.705.438,1.418.848,2.1,1.3l1.926,1.446a44.323,44.323,0,0,1,11.294,12.714,42.225,42.225,0,0,1,4.87,11.9,23.983,23.983,0,0,1,.559,2.442q.171,1.164.32,2.177c.092.675.205,1.295.257,1.868l.066,1.561.081,2.117C366.4,137.018,366.395,137.262,366.395,137.262Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8637",
    "data-name": "Group 8637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8636",
    "data-name": "Group 8636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8635",
    "data-name": "Group 8635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8634",
    "data-name": "Group 8634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8633",
    "data-name": "Group 8633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8632",
    "data-name": "Group 8632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8631",
    "data-name": "Group 8631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8630",
    "data-name": "Group 8630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8629",
    "data-name": "Group 8629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5978",
    "data-name": "Path 5978",
    d: "M326.331,137.913a10.177,10.177,0,1,0-7.4,0C303.288,140.127,304,156.1,304,156.1l37,.16S341.842,140.114,326.331,137.913Z",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8639",
    "data-name": "Group 8639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5979",
    "data-name": "Path 5979",
    d: "M252.863,315.244h-4.826a1.232,1.232,0,0,1-1.23-1.231v-4.825a1.232,1.232,0,0,1,1.23-1.23h4.826a1.231,1.231,0,0,1,1.229,1.23v4.825A1.231,1.231,0,0,1,252.863,315.244Zm-4.826-6.786a.731.731,0,0,0-.73.73v4.825a.732.732,0,0,0,.73.731h4.826a.731.731,0,0,0,.729-.731v-4.825a.73.73,0,0,0-.729-.73Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8640",
    "data-name": "Group 8640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5980",
    "data-name": "Path 5980",
    d: "M261.016,313.522l-.88-1.253c-.082.006-.169.012-.257.012h-1.007v1.241h-.583v-4.08h1.59c1.062,0,1.7.536,1.7,1.422a1.288,1.288,0,0,1-.9,1.288l.968,1.37ZM261,310.864c0-.583-.391-.915-1.137-.915h-.99v1.835h.99C260.608,311.784,261,311.447,261,310.864Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5981",
    "data-name": "Path 5981",
    d: "M265.23,312.163h-2.506a1.047,1.047,0,0,0,1.119.9,1.153,1.153,0,0,0,.892-.373l.309.361a1.683,1.683,0,0,1-2.879-1.078,1.512,1.512,0,0,1,1.549-1.573,1.489,1.489,0,0,1,1.528,1.591C265.242,312.041,265.236,312.112,265.23,312.163Zm-2.506-.4h1.982a1,1,0,0,0-1.982,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5982",
    "data-name": "Path 5982",
    d: "M271.151,311.745v1.777h-.56v-1.714c0-.606-.292-.9-.8-.9a.9.9,0,0,0-.927,1.026v1.591h-.56v-1.714c0-.606-.292-.9-.8-.9a.9.9,0,0,0-.926,1.026v1.591h-.56v-3.089h.536v.46a1.253,1.253,0,0,1,1.068-.489,1.143,1.143,0,0,1,1.072.571,1.39,1.39,0,0,1,1.188-.571A1.185,1.185,0,0,1,271.151,311.745Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5983",
    "data-name": "Path 5983",
    d: "M274.988,312.163h-2.506a1.046,1.046,0,0,0,1.119.9,1.154,1.154,0,0,0,.892-.373l.308.361a1.683,1.683,0,0,1-2.879-1.078,1.512,1.512,0,0,1,1.55-1.573A1.489,1.489,0,0,1,275,311.995C275,312.041,274.994,312.112,274.988,312.163Zm-2.506-.4h1.981a1,1,0,0,0-1.981,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5984",
    "data-name": "Path 5984",
    d: "M280.91,311.745v1.777h-.56v-1.714c0-.606-.292-.9-.8-.9a.9.9,0,0,0-.926,1.026v1.591h-.56v-1.714c0-.606-.292-.9-.8-.9a.9.9,0,0,0-.927,1.026v1.591h-.559v-3.089h.536v.46a1.253,1.253,0,0,1,1.067-.489,1.144,1.144,0,0,1,1.073.571,1.39,1.39,0,0,1,1.188-.571A1.185,1.185,0,0,1,280.91,311.745Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5985",
    "data-name": "Path 5985",
    d: "M285.148,311.977a1.5,1.5,0,0,1-1.562,1.58,1.307,1.307,0,0,1-1.1-.524v.489h-.536V309.2h.559v1.7a1.317,1.317,0,0,1,1.079-.495A1.5,1.5,0,0,1,285.148,311.977Zm-.565,0a1.042,1.042,0,1,0-1.043,1.09A1.019,1.019,0,0,0,284.583,311.977Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5986",
    "data-name": "Path 5986",
    d: "M288.709,312.163H286.2a1.046,1.046,0,0,0,1.119.9,1.151,1.151,0,0,0,.891-.373l.309.361a1.683,1.683,0,0,1-2.879-1.078,1.512,1.512,0,0,1,1.55-1.573,1.488,1.488,0,0,1,1.527,1.591C288.72,312.041,288.714,312.112,288.709,312.163Zm-2.506-.4h1.981a1,1,0,0,0-1.981,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5987",
    "data-name": "Path 5987",
    d: "M291.162,310.4v.542a.956.956,0,0,0-.128-.006.922.922,0,0,0-.974,1.043v1.539H289.5v-3.089h.536v.519A1.178,1.178,0,0,1,291.162,310.4Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5988",
    "data-name": "Path 5988",
    d: "M298.593,311.745v1.777h-.559v-1.714c0-.606-.292-.9-.8-.9a.9.9,0,0,0-.927,1.026v1.591h-.559v-1.714c0-.606-.292-.9-.8-.9a.9.9,0,0,0-.927,1.026v1.591h-.56v-3.089H294v.46a1.25,1.25,0,0,1,1.067-.489,1.142,1.142,0,0,1,1.072.571,1.392,1.392,0,0,1,1.189-.571A1.184,1.184,0,0,1,298.593,311.745Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5989",
    "data-name": "Path 5989",
    d: "M302.429,312.163h-2.506a1.047,1.047,0,0,0,1.12.9,1.151,1.151,0,0,0,.891-.373l.309.361a1.683,1.683,0,0,1-2.879-1.078,1.512,1.512,0,0,1,1.55-1.573,1.489,1.489,0,0,1,1.527,1.591A1.677,1.677,0,0,1,302.429,312.163Zm-2.506-.4H301.9a1,1,0,0,0-1.982,0Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8641",
    "data-name": "Group 8641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5990",
    "data-name": "Path 5990",
    d: "M342.4,309.949v1.422h2.046v.5H342.4v1.65h-.583v-4.08H344.7v.507Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5991",
    "data-name": "Path 5991",
    d: "M345.057,311.977a1.606,1.606,0,1,1,1.609,1.58A1.537,1.537,0,0,1,345.057,311.977Zm2.646,0a1.041,1.041,0,1,0-1.037,1.09A1.014,1.014,0,0,0,347.7,311.977Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5992",
    "data-name": "Path 5992",
    d: "M350.71,310.4v.542a.949.949,0,0,0-.128-.006.922.922,0,0,0-.974,1.043v1.539h-.56v-3.089h.537v.519A1.178,1.178,0,0,1,350.71,310.4Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5993",
    "data-name": "Path 5993",
    d: "M354.327,310.433V313.1a1.4,1.4,0,0,1-1.6,1.586,2.279,2.279,0,0,1-1.474-.461l.267-.431a1.893,1.893,0,0,0,1.19.4c.728,0,1.06-.338,1.06-1.038v-.245a1.408,1.408,0,0,1-1.113.479,1.5,1.5,0,1,1,0-2.99,1.408,1.408,0,0,1,1.142.506v-.477Zm-.548,1.463a1.065,1.065,0,1,0-1.061,1.008A.986.986,0,0,0,353.779,311.9Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5994",
    "data-name": "Path 5994",
    d: "M355.113,311.977a1.606,1.606,0,1,1,1.608,1.58A1.536,1.536,0,0,1,355.113,311.977Zm2.646,0a1.042,1.042,0,1,0-1.038,1.09A1.014,1.014,0,0,0,357.759,311.977Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5995",
    "data-name": "Path 5995",
    d: "M360.841,313.341a1.053,1.053,0,0,1-.676.216.882.882,0,0,1-.979-.968v-1.7h-.524v-.46h.524v-.677h.56v.677h.885v.46h-.885v1.673a.454.454,0,0,0,.483.518.705.705,0,0,0,.438-.145Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5996",
    "data-name": "Path 5996",
    d: "M366.465,310.864c0,.886-.641,1.422-1.7,1.422h-1.008v1.236h-.583v-4.08h1.591C365.824,309.442,366.465,309.978,366.465,310.864Zm-.583,0c0-.583-.39-.915-1.136-.915h-.991v1.83h.991C365.492,311.779,365.882,311.447,365.882,310.864Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5997",
    "data-name": "Path 5997",
    d: "M369.665,311.657v1.865h-.531v-.408a1.145,1.145,0,0,1-1.014.443c-.7,0-1.143-.373-1.143-.909,0-.5.321-.9,1.242-.9h.886v-.112c0-.472-.273-.746-.828-.746a1.562,1.562,0,0,0-.979.332l-.233-.419a2.052,2.052,0,0,1,1.276-.4C369.187,310.4,369.665,310.812,369.665,311.657Zm-.56.92v-.431h-.862c-.554,0-.712.216-.712.478,0,.309.257.5.682.5A.9.9,0,0,0,369.105,312.577Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5998",
    "data-name": "Path 5998",
    d: "M370.316,313.2l.233-.444a1.983,1.983,0,0,0,1.084.321c.519,0,.735-.158.735-.419,0-.695-1.952-.094-1.952-1.324,0-.553.5-.926,1.288-.926a2.249,2.249,0,0,1,1.125.279l-.24.443a1.615,1.615,0,0,0-.891-.245c-.49,0-.729.181-.729.426,0,.728,1.958.134,1.958,1.335,0,.56-.512.915-1.335.915A2.232,2.232,0,0,1,370.316,313.2Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5999",
    "data-name": "Path 5999",
    d: "M373.24,313.2l.233-.444a1.983,1.983,0,0,0,1.084.321c.519,0,.735-.158.735-.419,0-.695-1.953-.094-1.953-1.324,0-.553.5-.926,1.289-.926a2.249,2.249,0,0,1,1.125.279l-.24.443a1.617,1.617,0,0,0-.891-.245c-.491,0-.729.181-.729.426,0,.728,1.958.134,1.958,1.335,0,.56-.513.915-1.335.915A2.232,2.232,0,0,1,373.24,313.2Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6000",
    "data-name": "Path 6000",
    d: "M381.171,310.433l-1.154,3.089h-.536l-.892-2.343-.9,2.343h-.536L376,310.433h.53l.9,2.459.933-2.459h.473l.915,2.471.92-2.471Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6001",
    "data-name": "Path 6001",
    d: "M381.371,311.977a1.606,1.606,0,1,1,1.608,1.58A1.536,1.536,0,0,1,381.371,311.977Zm2.646,0a1.042,1.042,0,1,0-1.038,1.09A1.014,1.014,0,0,0,384.017,311.977Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6002",
    "data-name": "Path 6002",
    d: "M387.022,310.4v.542a.949.949,0,0,0-.128-.006.922.922,0,0,0-.974,1.043v1.539h-.559v-3.089h.536v.519A1.178,1.178,0,0,1,387.022,310.4Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6003",
    "data-name": "Path 6003",
    d: "M390.6,309.2v4.325h-.537v-.489a1.3,1.3,0,0,1-1.1.524,1.577,1.577,0,0,1,0-3.153,1.317,1.317,0,0,1,1.079.495v-1.7Zm-.554,2.78a1.042,1.042,0,1,0-1.038,1.09A1.017,1.017,0,0,0,390.045,311.977Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6004",
    "data-name": "Path 6004",
    d: "M393.489,310.52c0-.373-.309-.63-.833-.63a1.242,1.242,0,0,0-1.044.461l-.425-.3a1.811,1.811,0,0,1,1.51-.653c.839,0,1.381.39,1.381,1.038,0,.973-1.032,1.037-1.032,1.8h-.583C392.463,311.319,393.489,311.19,393.489,310.52Zm-1.108,2.664a.376.376,0,1,1,.379.373A.366.366,0,0,1,392.381,313.184Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8642",
    "data-name": "Group 8642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6005",
    "data-name": "Path 6005",
    d: "M250.1,313.1a.375.375,0,0,1-.238-.085l-1.062-.871a.375.375,0,0,1,.476-.58l.788.646,1.828-1.993a.375.375,0,0,1,.553.508l-2.068,2.254A.376.376,0,0,1,250.1,313.1Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8651",
    "data-name": "Group 8651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8650",
    "data-name": "Group 8650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8649",
    "data-name": "Group 8649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8648",
    "data-name": "Group 8648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8647",
    "data-name": "Group 8647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8646",
    "data-name": "Group 8646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8645",
    "data-name": "Group 8645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8644",
    "data-name": "Group 8644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8643",
    "data-name": "Group 8643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6006",
    "data-name": "Path 6006",
    d: "M383.268,208.417a3.12,3.12,0,0,0,1.858-2.886,2.931,2.931,0,1,0-5.85-.027,3.113,3.113,0,0,0,1.864,2.913c-4.5.678-4.3,5.57-4.3,5.57l10.645.05S387.73,209.091,383.268,208.417Z",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8659",
    "data-name": "Group 8659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8654",
    "data-name": "Group 8654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8653",
    "data-name": "Group 8653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6007",
    "data-name": "Path 6007",
    d: "M406.465,79.127h10.711a.625.625,0,0,0,0-1.25H406.465a.625.625,0,0,0,0,1.25Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8656",
    "data-name": "Group 8656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8655",
    "data-name": "Group 8655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6008",
    "data-name": "Path 6008",
    d: "M406.465,82.5h10.711a.625.625,0,0,0,0-1.25H406.465a.625.625,0,0,0,0,1.25Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8658",
    "data-name": "Group 8658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8657",
    "data-name": "Group 8657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6009",
    "data-name": "Path 6009",
    d: "M406.465,85.871h10.711a.625.625,0,0,0,0-1.25H406.465a.625.625,0,0,0,0,1.25Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9115",
    "data-name": "Group 9115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8666",
    "data-name": "Group 8666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8665",
    "data-name": "Group 8665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8664",
    "data-name": "Group 8664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8663",
    "data-name": "Group 8663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8662",
    "data-name": "Group 8662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8661",
    "data-name": "Group 8661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6010",
    "data-name": "Path 6010",
    d: "M400.426,350.814a6.267,6.267,0,0,1,.438,2.738,9.13,9.13,0,0,1,1.243-3.1c.224-.353.58-.734.986-.63s.536.614.551,1.034a6.716,6.716,0,0,1-.757,3.333,7.43,7.43,0,0,1,2.82-2.185.671.671,0,0,1,.611-.048c.212.132.217.434.182.681a5.71,5.71,0,0,1-3.465,4.4l-.6.087a5.316,5.316,0,0,1-3.812-6.1c.093-.494.374-1.068.876-1.077C399.953,349.938,400.258,350.4,400.426,350.814Z",
    fill: "#ff725e"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9107",
    "data-name": "Group 9107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8743",
    "data-name": "Group 8743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8672",
    "data-name": "Group 8672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8671",
    "data-name": "Group 8671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8670",
    "data-name": "Group 8670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8669",
    "data-name": "Group 8669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8668",
    "data-name": "Group 8668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8667",
    "data-name": "Group 8667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6011",
    "data-name": "Path 6011",
    d: "M413.815,377.555a17.2,17.2,0,0,0-5.675-2.287,23.329,23.329,0,0,0,.16-12.542,12,12,0,0,0-2.118-4.514,6.165,6.165,0,0,0-4.262-2.38,5.992,5.992,0,0,0-4.735,2.193l-2.1,4.845a18.648,18.648,0,0,0-.251,2.128,25.573,25.573,0,0,0,3.058,13.549c-2.183,2.407-4.546,6.556-3.834,11.364h24.871C419.368,385.3,417.612,380.3,413.815,377.555Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8679",
    "data-name": "Group 8679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8678",
    "data-name": "Group 8678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8677",
    "data-name": "Group 8677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8676",
    "data-name": "Group 8676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8675",
    "data-name": "Group 8675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8674",
    "data-name": "Group 8674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8673",
    "data-name": "Group 8673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6012",
    "data-name": "Path 6012",
    d: "M396.788,380.093c-.01-.008.054-.1.188-.27a7.483,7.483,0,0,1,.615-.715A11.5,11.5,0,0,1,400.349,377a13,13,0,0,1,4.9-1.566,11.877,11.877,0,0,1,11.152,4.807,13,13,0,0,1,2.229,4.642,11.508,11.508,0,0,1,.361,3.452,7.6,7.6,0,0,1-.1.939,1.153,1.153,0,0,1-.067.322,15.18,15.18,0,0,0-.455-4.644,13.119,13.119,0,0,0-2.248-4.5,11.713,11.713,0,0,0-10.838-4.672,13.149,13.149,0,0,0-4.815,1.455A15.149,15.149,0,0,0,396.788,380.093Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8686",
    "data-name": "Group 8686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8685",
    "data-name": "Group 8685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8684",
    "data-name": "Group 8684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8683",
    "data-name": "Group 8683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8682",
    "data-name": "Group 8682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8681",
    "data-name": "Group 8681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8680",
    "data-name": "Group 8680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6013",
    "data-name": "Path 6013",
    d: "M394.71,366.781a6.149,6.149,0,0,1-.045-1.648,14.368,14.368,0,0,1,.67-3.935,8.082,8.082,0,0,1,2.129-3.385,3.385,3.385,0,0,1,1.4-.885c.033.057-.524.359-1.216,1.076a8.886,8.886,0,0,0-1.957,3.316,18.226,18.226,0,0,0-.762,3.833A8.5,8.5,0,0,1,394.71,366.781Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8693",
    "data-name": "Group 8693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8692",
    "data-name": "Group 8692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8691",
    "data-name": "Group 8691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8690",
    "data-name": "Group 8690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8689",
    "data-name": "Group 8689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8688",
    "data-name": "Group 8688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8687",
    "data-name": "Group 8687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6014",
    "data-name": "Path 6014",
    d: "M409.091,386.746a98.781,98.781,0,0,1,4.724-4.67,17.3,17.3,0,0,1-4.724,4.67Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8700",
    "data-name": "Group 8700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8699",
    "data-name": "Group 8699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8698",
    "data-name": "Group 8698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8697",
    "data-name": "Group 8697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8696",
    "data-name": "Group 8696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8695",
    "data-name": "Group 8695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8694",
    "data-name": "Group 8694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6015",
    "data-name": "Path 6015",
    d: "M406.318,385.3a16.547,16.547,0,0,1,1.175-4.845,16.55,16.55,0,0,1-1.175,4.845Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8707",
    "data-name": "Group 8707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8706",
    "data-name": "Group 8706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8705",
    "data-name": "Group 8705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8704",
    "data-name": "Group 8704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8703",
    "data-name": "Group 8703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8702",
    "data-name": "Group 8702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8701",
    "data-name": "Group 8701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6016",
    "data-name": "Path 6016",
    d: "M398.933,382.537a9.8,9.8,0,0,1,2.176,4.794,16.711,16.711,0,0,1-1.1-2.39A16.985,16.985,0,0,1,398.933,382.537Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8714",
    "data-name": "Group 8714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8713",
    "data-name": "Group 8713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8712",
    "data-name": "Group 8712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8711",
    "data-name": "Group 8711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8710",
    "data-name": "Group 8710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8709",
    "data-name": "Group 8709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8708",
    "data-name": "Group 8708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6017",
    "data-name": "Path 6017",
    d: "M406.92,370.922a24.6,24.6,0,0,1,3.666-4.848,24.5,24.5,0,0,1-3.666,4.848Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8721",
    "data-name": "Group 8721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8720",
    "data-name": "Group 8720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8719",
    "data-name": "Group 8719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8718",
    "data-name": "Group 8718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8717",
    "data-name": "Group 8717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8716",
    "data-name": "Group 8716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8715",
    "data-name": "Group 8715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6018",
    "data-name": "Path 6018",
    d: "M405.164,363.143a35.253,35.253,0,0,1,4.12-6.013,35.408,35.408,0,0,1-4.12,6.013Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8728",
    "data-name": "Group 8728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8727",
    "data-name": "Group 8727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8726",
    "data-name": "Group 8726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8725",
    "data-name": "Group 8725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8724",
    "data-name": "Group 8724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8723",
    "data-name": "Group 8723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8722",
    "data-name": "Group 8722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6019",
    "data-name": "Path 6019",
    d: "M402.362,365.184a18.71,18.71,0,0,1,.331,5.293,18.71,18.71,0,0,1-.331-5.293Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8735",
    "data-name": "Group 8735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8734",
    "data-name": "Group 8734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8733",
    "data-name": "Group 8733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8732",
    "data-name": "Group 8732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8731",
    "data-name": "Group 8731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8730",
    "data-name": "Group 8730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8729",
    "data-name": "Group 8729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6020",
    "data-name": "Path 6020",
    d: "M391.189,368.723a26.354,26.354,0,0,1,6.748,4.115,97.221,97.221,0,0,1-6.748-4.115Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8742",
    "data-name": "Group 8742",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8741",
    "data-name": "Group 8741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8740",
    "data-name": "Group 8740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8739",
    "data-name": "Group 8739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8738",
    "data-name": "Group 8738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8737",
    "data-name": "Group 8737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8736",
    "data-name": "Group 8736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6021",
    "data-name": "Path 6021",
    d: "M400.142,375.419a8.758,8.758,0,0,1,4.032-.995c1.449-.072,3.07.074,4.051,1.143v.052a15.059,15.059,0,0,0-10.214,3.187A4.058,4.058,0,0,1,400.142,375.419Z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8749",
    "data-name": "Group 8749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8748",
    "data-name": "Group 8748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8747",
    "data-name": "Group 8747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8746",
    "data-name": "Group 8746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8745",
    "data-name": "Group 8745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8744",
    "data-name": "Group 8744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6022",
    "data-name": "Path 6022",
    d: "M411.964,326.571a4.943,4.943,0,0,1,2.181-.084,7.2,7.2,0,0,1-2.307-1.264c-.255-.209-.519-.523-.4-.83s.53-.362.86-.334a5.293,5.293,0,0,1,2.535.906,5.857,5.857,0,0,1-1.443-2.41.531.531,0,0,1,.02-.483c.123-.153.36-.129.549-.078a4.5,4.5,0,0,1,3.118,3.124l.012.474a4.186,4.186,0,0,1-5.131,2.4c-.377-.119-.8-.392-.76-.785C411.234,326.859,411.621,326.663,411.964,326.571Z",
    fill: "#ff725e"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8755",
    "data-name": "Group 8755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8754",
    "data-name": "Group 8754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8753",
    "data-name": "Group 8753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8752",
    "data-name": "Group 8752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8751",
    "data-name": "Group 8751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8750",
    "data-name": "Group 8750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6023",
    "data-name": "Path 6023",
    d: "M462.128,294.782a4.94,4.94,0,0,1-.1,2.18,7.194,7.194,0,0,1,1.453-2.193c.229-.236.564-.473.86-.329s.316.559.261.885a5.292,5.292,0,0,1-1.115,2.45,5.842,5.842,0,0,1,2.522-1.235.529.529,0,0,1,.479.06c.142.135.1.369.032.554A4.5,4.5,0,0,1,463.147,300l-.473-.028a4.185,4.185,0,0,1-1.967-5.315c.15-.366.458-.764.847-.691C461.9,294.031,462.065,294.433,462.128,294.782Z",
    fill: "#ff725e"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8761",
    "data-name": "Group 8761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8760",
    "data-name": "Group 8760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8759",
    "data-name": "Group 8759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8758",
    "data-name": "Group 8758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8757",
    "data-name": "Group 8757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8756",
    "data-name": "Group 8756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6024",
    "data-name": "Path 6024",
    d: "M427.2,359.819c.368.014.713.057,1.065.09.646-7.105-1.508-14.319.662-21.111l-.289.37a16.085,16.085,0,0,1-7.8-.7,9.759,9.759,0,0,1-5.64-5.226,7.052,7.052,0,0,1,1.2-7.384c2.46-2.57,6.791-2.435,9.877-.665,2.976,1.708,5.062,4.576,7.026,7.4a13.016,13.016,0,0,1,3.4-1.953c-3.428-4.72-6.743-9.676-7.825-15.377-1.183-6.238,1.147-13.629,6.937-16.233,4.931-2.218,11.114-.214,14.59,3.928.272.324.5.675.744,1.018l-.117-.336a8.983,8.983,0,0,1,4.689-4.937,7.629,7.629,0,0,1,6.731.323,6.64,6.64,0,0,1,3.307,5.777,7.4,7.4,0,0,1-4.283,6.149,11.584,11.584,0,0,1-7.38.682,22.437,22.437,0,0,1-.037,6.627,38.226,38.226,0,0,1-5.614,13.87,12.313,12.313,0,0,1,2.022,1.671c4.468,4.678,4.755,12.19,2.414,18.221S444.2,362.5,439.8,367.247l-.005,0a28.76,28.76,0,0,1,3.379,10.61,9.66,9.66,0,0,1,8.516-5.466c1.92.015,4.071.869,4.666,2.694.523,1.609-.358,3.352-1.5,4.6a12.211,12.211,0,0,1-11.262,3.3l-.048-1.175a50.974,50.974,0,0,1-.2,8.107H414.971S407.387,359.085,427.2,359.819Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8784",
    "data-name": "Group 8784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8768",
    "data-name": "Group 8768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8767",
    "data-name": "Group 8767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8766",
    "data-name": "Group 8766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8765",
    "data-name": "Group 8765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8764",
    "data-name": "Group 8764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8763",
    "data-name": "Group 8763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8762",
    "data-name": "Group 8762"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 67.152,
    height: 11.902,
    transform: "translate(449.591 401.813) rotate(180)",
    fill: "#ff725e"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8775",
    "data-name": "Group 8775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8774",
    "data-name": "Group 8774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8773",
    "data-name": "Group 8773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8772",
    "data-name": "Group 8772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8771",
    "data-name": "Group 8771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8770",
    "data-name": "Group 8770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8769",
    "data-name": "Group 8769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6025",
    "data-name": "Path 6025",
    d: "M444.576,399.452l-8.166,35.566H396.388l-8.934-35.566Z",
    fill: "#ff725e"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8783",
    "data-name": "Group 8783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8782",
    "data-name": "Group 8782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8781",
    "data-name": "Group 8781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8780",
    "data-name": "Group 8780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8779",
    "data-name": "Group 8779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8778",
    "data-name": "Group 8778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8777",
    "data-name": "Group 8777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8776",
    "data-name": "Group 8776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6026",
    "data-name": "Path 6026",
    d: "M382.476,401.828c0,.13,15.147.236,33.828.236s33.83-.106,33.83-.236-15.143-.236-33.83-.236S382.476,401.7,382.476,401.828Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8791",
    "data-name": "Group 8791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8790",
    "data-name": "Group 8790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8789",
    "data-name": "Group 8789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8788",
    "data-name": "Group 8788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8787",
    "data-name": "Group 8787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8786",
    "data-name": "Group 8786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8785",
    "data-name": "Group 8785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6027",
    "data-name": "Path 6027",
    d: "M421.938,360.991a2,2,0,0,1,.388-.221,8.6,8.6,0,0,1,1.179-.5,11.515,11.515,0,0,1,4.673-.539,14.245,14.245,0,0,1,6.577,2.3,17.648,17.648,0,0,1,5.648,6.39,25.975,25.975,0,0,1,2.7,8.111,43.6,43.6,0,0,1,.456,6.966c-.011,1.985-.074,3.589-.114,4.7-.023.521-.041.944-.055,1.276a1.977,1.977,0,0,1-.044.444,2.032,2.032,0,0,1-.032-.445c0-.333-.01-.756-.016-1.277,0-1.157,0-2.748-.006-4.692a46.117,46.117,0,0,0-.532-6.911,26.222,26.222,0,0,0-2.693-7.988,17.529,17.529,0,0,0-5.509-6.28,14.215,14.215,0,0,0-6.408-2.326,11.948,11.948,0,0,0-4.6.413C422.5,360.729,421.959,361.035,421.938,360.991Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8798",
    "data-name": "Group 8798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8797",
    "data-name": "Group 8797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8796",
    "data-name": "Group 8796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8795",
    "data-name": "Group 8795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8794",
    "data-name": "Group 8794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8793",
    "data-name": "Group 8793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8792",
    "data-name": "Group 8792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6028",
    "data-name": "Path 6028",
    d: "M427.939,345.924a1.173,1.173,0,0,1-.046-.337c-.009-.221-.053-.549-.039-.971a15.949,15.949,0,0,1,.42-3.554,16.7,16.7,0,0,1,1.972-4.931,13.616,13.616,0,0,1,1.9-2.513,11.222,11.222,0,0,1,5.826-3.325,13.154,13.154,0,0,1,3.151-.234,15.453,15.453,0,0,1,5.169,1.227A17.383,17.383,0,0,1,449.436,333c.354.23.6.447.78.58s.262.215.254.226a11.594,11.594,0,0,1-1.114-.682,19.944,19.944,0,0,0-3.162-1.589,15.731,15.731,0,0,0-5.084-1.126,13.1,13.1,0,0,0-3.057.247,11.151,11.151,0,0,0-3.059,1.185,11.038,11.038,0,0,0-2.578,2.035,13.449,13.449,0,0,0-1.872,2.438,17.026,17.026,0,0,0-2.01,4.813A18.053,18.053,0,0,0,428,344.62,12.634,12.634,0,0,1,427.939,345.924Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8805",
    "data-name": "Group 8805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8804",
    "data-name": "Group 8804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8803",
    "data-name": "Group 8803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8802",
    "data-name": "Group 8802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8801",
    "data-name": "Group 8801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8800",
    "data-name": "Group 8800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8799",
    "data-name": "Group 8799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6029",
    "data-name": "Path 6029",
    d: "M454.321,315.895a13.391,13.391,0,0,1-.24-2.279c-.055-.7-.127-1.537-.281-2.45a12.029,12.029,0,0,0-.8-2.881,29.4,29.4,0,0,0-2.593-4.827c-.775-1.173-1.363-1.819-1.321-1.86.018-.017.186.125.466.409a13.574,13.574,0,0,1,1.074,1.3,23.934,23.934,0,0,1,2.724,4.837,11.494,11.494,0,0,1,.8,2.969,21.1,21.1,0,0,1,.2,2.491A14.239,14.239,0,0,1,454.321,315.895Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8812",
    "data-name": "Group 8812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8811",
    "data-name": "Group 8811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8810",
    "data-name": "Group 8810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8809",
    "data-name": "Group 8809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8808",
    "data-name": "Group 8808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8807",
    "data-name": "Group 8807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8806",
    "data-name": "Group 8806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6030",
    "data-name": "Path 6030",
    d: "M450.658,379.71a15.317,15.317,0,0,1,3.621,3.146,15.264,15.264,0,0,1-3.621-3.146Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8819",
    "data-name": "Group 8819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8818",
    "data-name": "Group 8818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8817",
    "data-name": "Group 8817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8816",
    "data-name": "Group 8816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8815",
    "data-name": "Group 8815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8814",
    "data-name": "Group 8814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8813",
    "data-name": "Group 8813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6031",
    "data-name": "Path 6031",
    d: "M453.041,377.339a15.761,15.761,0,0,1,4.849-.473,15.849,15.849,0,0,1-4.849.473Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8826",
    "data-name": "Group 8826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8825",
    "data-name": "Group 8825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8824",
    "data-name": "Group 8824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8823",
    "data-name": "Group 8823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8822",
    "data-name": "Group 8822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8821",
    "data-name": "Group 8821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8820",
    "data-name": "Group 8820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6032",
    "data-name": "Path 6032",
    d: "M451.234,373.152a434.344,434.344,0,0,1,2.708-3.723,7.324,7.324,0,0,1-2.708,3.723Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8833",
    "data-name": "Group 8833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8832",
    "data-name": "Group 8832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8831",
    "data-name": "Group 8831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8830",
    "data-name": "Group 8830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8829",
    "data-name": "Group 8829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8828",
    "data-name": "Group 8828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8827",
    "data-name": "Group 8827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6033",
    "data-name": "Path 6033",
    d: "M448.056,371.23a20.536,20.536,0,0,1-1.246,5.414,20.511,20.511,0,0,1,1.246-5.414Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8840",
    "data-name": "Group 8840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8839",
    "data-name": "Group 8839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8838",
    "data-name": "Group 8838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8837",
    "data-name": "Group 8837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8836",
    "data-name": "Group 8836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8835",
    "data-name": "Group 8835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8834",
    "data-name": "Group 8834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6034",
    "data-name": "Path 6034",
    d: "M445.932,380.824c-.07-.078.378-.6,1-1.156s1.185-.952,1.255-.875-.379.6-1,1.156S446,380.9,445.932,380.824Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8847",
    "data-name": "Group 8847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8846",
    "data-name": "Group 8846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8845",
    "data-name": "Group 8845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8844",
    "data-name": "Group 8844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8843",
    "data-name": "Group 8843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8842",
    "data-name": "Group 8842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8841",
    "data-name": "Group 8841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6035",
    "data-name": "Path 6035",
    d: "M436.063,378.966a5.25,5.25,0,0,1,1.217-1.542c.747-.779,1.414-1.352,1.489-1.28a5.23,5.23,0,0,1-1.217,1.542C436.8,378.465,436.138,379.038,436.063,378.966Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8854",
    "data-name": "Group 8854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8853",
    "data-name": "Group 8853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8852",
    "data-name": "Group 8852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8851",
    "data-name": "Group 8851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8850",
    "data-name": "Group 8850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8849",
    "data-name": "Group 8849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8848",
    "data-name": "Group 8848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6036",
    "data-name": "Path 6036",
    d: "M433.921,369.853a11.252,11.252,0,0,1,2.142-3.5,11.22,11.22,0,0,1-2.142,3.5Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8861",
    "data-name": "Group 8861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8860",
    "data-name": "Group 8860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8859",
    "data-name": "Group 8859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8858",
    "data-name": "Group 8858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8857",
    "data-name": "Group 8857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8856",
    "data-name": "Group 8856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8855",
    "data-name": "Group 8855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6037",
    "data-name": "Path 6037",
    d: "M427.638,362.434a14.943,14.943,0,0,1,.062,4.738,14.944,14.944,0,0,1-.062-4.738Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8868",
    "data-name": "Group 8868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8867",
    "data-name": "Group 8867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8866",
    "data-name": "Group 8866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8865",
    "data-name": "Group 8865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8864",
    "data-name": "Group 8864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8863",
    "data-name": "Group 8863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8862",
    "data-name": "Group 8862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6038",
    "data-name": "Path 6038",
    d: "M414.452,364.949a78.583,78.583,0,0,1,3.669,4.446,12.945,12.945,0,0,1-3.669-4.446Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8875",
    "data-name": "Group 8875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8874",
    "data-name": "Group 8874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8873",
    "data-name": "Group 8873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8872",
    "data-name": "Group 8872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8871",
    "data-name": "Group 8871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8870",
    "data-name": "Group 8870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8869",
    "data-name": "Group 8869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6039",
    "data-name": "Path 6039",
    d: "M412.761,377.9a14.756,14.756,0,0,1,4.627.894,14.83,14.83,0,0,1-4.627-.894Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8882",
    "data-name": "Group 8882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8881",
    "data-name": "Group 8881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8880",
    "data-name": "Group 8880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8879",
    "data-name": "Group 8879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8878",
    "data-name": "Group 8878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8877",
    "data-name": "Group 8877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8876",
    "data-name": "Group 8876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6040",
    "data-name": "Path 6040",
    d: "M426.438,382.412a10.42,10.42,0,0,1,2.462-4.857,233.091,233.091,0,0,1-2.462,4.857Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8889",
    "data-name": "Group 8889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8888",
    "data-name": "Group 8888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8887",
    "data-name": "Group 8887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8886",
    "data-name": "Group 8886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8885",
    "data-name": "Group 8885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8884",
    "data-name": "Group 8884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8883",
    "data-name": "Group 8883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6041",
    "data-name": "Path 6041",
    d: "M421.88,376.2a9.83,9.83,0,0,1-.086-3.836,9.83,9.83,0,0,1,.086,3.836Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8896",
    "data-name": "Group 8896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8895",
    "data-name": "Group 8895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8894",
    "data-name": "Group 8894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8893",
    "data-name": "Group 8893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8892",
    "data-name": "Group 8892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8891",
    "data-name": "Group 8891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8890",
    "data-name": "Group 8890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6042",
    "data-name": "Path 6042",
    d: "M436.6,387.153a6.383,6.383,0,0,1,2.225-3.624,168.1,168.1,0,0,1-2.225,3.624Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903",
    "data-name": "Group 8903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8902",
    "data-name": "Group 8902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8901",
    "data-name": "Group 8901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8900",
    "data-name": "Group 8900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8899",
    "data-name": "Group 8899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8898",
    "data-name": "Group 8898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8897",
    "data-name": "Group 8897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6043",
    "data-name": "Path 6043",
    d: "M420.983,388.051a11.735,11.735,0,0,1-1.693-3.835,11.736,11.736,0,0,1,1.693,3.835Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8910",
    "data-name": "Group 8910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8909",
    "data-name": "Group 8909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8908",
    "data-name": "Group 8908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8907",
    "data-name": "Group 8907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8906",
    "data-name": "Group 8906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8905",
    "data-name": "Group 8905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8904",
    "data-name": "Group 8904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6044",
    "data-name": "Path 6044",
    d: "M445.254,359.177a17.981,17.981,0,0,1,5.192.171,17.981,17.981,0,0,1-5.192-.171Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8917",
    "data-name": "Group 8917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8916",
    "data-name": "Group 8916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8915",
    "data-name": "Group 8915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8914",
    "data-name": "Group 8914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8913",
    "data-name": "Group 8913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8912",
    "data-name": "Group 8912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8911",
    "data-name": "Group 8911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6045",
    "data-name": "Path 6045",
    d: "M450.915,349.488a27.02,27.02,0,0,1,5.211-3.693,27.137,27.137,0,0,1-5.211,3.693Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8924",
    "data-name": "Group 8924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8923",
    "data-name": "Group 8923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8922",
    "data-name": "Group 8922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8921",
    "data-name": "Group 8921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8920",
    "data-name": "Group 8920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8919",
    "data-name": "Group 8919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8918",
    "data-name": "Group 8918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6046",
    "data-name": "Path 6046",
    d: "M450.328,337.042a1121.622,1121.622,0,0,0,4.068-2.7,8.013,8.013,0,0,1-4.068,2.7Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8931",
    "data-name": "Group 8931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8930",
    "data-name": "Group 8930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8929",
    "data-name": "Group 8929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8928",
    "data-name": "Group 8928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8927",
    "data-name": "Group 8927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8926",
    "data-name": "Group 8926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8925",
    "data-name": "Group 8925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6047",
    "data-name": "Path 6047",
    d: "M443.985,332.643a25.187,25.187,0,0,1,1.467-5.979,25.183,25.183,0,0,1-1.467,5.979Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8938",
    "data-name": "Group 8938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8937",
    "data-name": "Group 8937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8936",
    "data-name": "Group 8936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8935",
    "data-name": "Group 8935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8934",
    "data-name": "Group 8934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8933",
    "data-name": "Group 8933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8932",
    "data-name": "Group 8932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6048",
    "data-name": "Path 6048",
    d: "M433.384,329.505a12.887,12.887,0,0,1,2.138,3.839,12.887,12.887,0,0,1-2.138-3.839Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8945",
    "data-name": "Group 8945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8944",
    "data-name": "Group 8944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8943",
    "data-name": "Group 8943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8942",
    "data-name": "Group 8942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8941",
    "data-name": "Group 8941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8940",
    "data-name": "Group 8940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8939",
    "data-name": "Group 8939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6049",
    "data-name": "Path 6049",
    d: "M424.246,350.505c.071-.085,1.28.84,2.871,1.819s2.955,1.651,2.912,1.752a14.058,14.058,0,0,1-5.783-3.571Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8952",
    "data-name": "Group 8952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8951",
    "data-name": "Group 8951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8950",
    "data-name": "Group 8950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8949",
    "data-name": "Group 8949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8948",
    "data-name": "Group 8948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8947",
    "data-name": "Group 8947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8946",
    "data-name": "Group 8946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6050",
    "data-name": "Path 6050",
    d: "M439.058,355.227a13.5,13.5,0,0,1,3.838-2.366,13.54,13.54,0,0,1-3.838,2.366Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8959",
    "data-name": "Group 8959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8958",
    "data-name": "Group 8958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8957",
    "data-name": "Group 8957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8956",
    "data-name": "Group 8956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8955",
    "data-name": "Group 8955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8954",
    "data-name": "Group 8954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8953",
    "data-name": "Group 8953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6051",
    "data-name": "Path 6051",
    d: "M441.541,345.183c-.077-.083.88-1.023,1.77-2.4s1.379-2.619,1.485-2.582a8.338,8.338,0,0,1-3.255,4.977Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8966",
    "data-name": "Group 8966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8965",
    "data-name": "Group 8965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8964",
    "data-name": "Group 8964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8963",
    "data-name": "Group 8963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8962",
    "data-name": "Group 8962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8961",
    "data-name": "Group 8961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8960",
    "data-name": "Group 8960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6052",
    "data-name": "Path 6052",
    d: "M436.676,342.916a15.677,15.677,0,0,1,.226-4.851,15.673,15.673,0,0,1-.226,4.851Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8973",
    "data-name": "Group 8973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8972",
    "data-name": "Group 8972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8971",
    "data-name": "Group 8971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8970",
    "data-name": "Group 8970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8969",
    "data-name": "Group 8969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8968",
    "data-name": "Group 8968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8967",
    "data-name": "Group 8967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6053",
    "data-name": "Path 6053",
    d: "M433.99,352.843a16.626,16.626,0,0,1-.573-4.963,16.626,16.626,0,0,1,.573,4.963Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8980",
    "data-name": "Group 8980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8979",
    "data-name": "Group 8979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8978",
    "data-name": "Group 8978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8977",
    "data-name": "Group 8977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8976",
    "data-name": "Group 8976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8975",
    "data-name": "Group 8975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8974",
    "data-name": "Group 8974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6054",
    "data-name": "Path 6054",
    d: "M426.481,322.938a397720.008,397720.008,0,0,1,1.584,5.556,11.246,11.246,0,0,1-1.584-5.556Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8987",
    "data-name": "Group 8987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8986",
    "data-name": "Group 8986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8985",
    "data-name": "Group 8985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8984",
    "data-name": "Group 8984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8983",
    "data-name": "Group 8983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8982",
    "data-name": "Group 8982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8981",
    "data-name": "Group 8981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6055",
    "data-name": "Path 6055",
    d: "M421.19,340.373a259.015,259.015,0,0,1,4.356-3.173,10.16,10.16,0,0,1-4.356,3.173Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8994",
    "data-name": "Group 8994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8993",
    "data-name": "Group 8993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8992",
    "data-name": "Group 8992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8991",
    "data-name": "Group 8991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8990",
    "data-name": "Group 8990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8989",
    "data-name": "Group 8989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8988",
    "data-name": "Group 8988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6056",
    "data-name": "Path 6056",
    d: "M414,335.019a120.976,120.976,0,0,1,5.3-1.015,10.653,10.653,0,0,1-5.3,1.015Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9001",
    "data-name": "Group 9001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9000",
    "data-name": "Group 9000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8999",
    "data-name": "Group 8999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8998",
    "data-name": "Group 8998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8997",
    "data-name": "Group 8997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8996",
    "data-name": "Group 8996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8995",
    "data-name": "Group 8995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6057",
    "data-name": "Path 6057",
    d: "M421,329.04a3.877,3.877,0,0,1,1.512.743c.779.5,1.364.974,1.308,1.062a3.877,3.877,0,0,1-1.512-.743C421.528,329.6,420.942,329.128,421,329.04Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9008",
    "data-name": "Group 9008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9007",
    "data-name": "Group 9007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9006",
    "data-name": "Group 9006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9005",
    "data-name": "Group 9005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9004",
    "data-name": "Group 9004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9003",
    "data-name": "Group 9003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9002",
    "data-name": "Group 9002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6058",
    "data-name": "Path 6058",
    d: "M417.506,322.581A6.88,6.88,0,0,1,420.4,325.9a155.363,155.363,0,0,1-2.894-3.322Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9015",
    "data-name": "Group 9015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9014",
    "data-name": "Group 9014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9013",
    "data-name": "Group 9013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9012",
    "data-name": "Group 9012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9011",
    "data-name": "Group 9011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9010",
    "data-name": "Group 9010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9009",
    "data-name": "Group 9009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6059",
    "data-name": "Path 6059",
    d: "M412.75,328.735a68.166,68.166,0,0,1,4.866,1.308,9.77,9.77,0,0,1-4.866-1.308Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9022",
    "data-name": "Group 9022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9021",
    "data-name": "Group 9021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9020",
    "data-name": "Group 9020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9019",
    "data-name": "Group 9019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9018",
    "data-name": "Group 9018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9017",
    "data-name": "Group 9017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9016",
    "data-name": "Group 9016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6060",
    "data-name": "Path 6060",
    d: "M445.709,320.454a36.257,36.257,0,0,1,2.146-3.271,36.783,36.783,0,0,1,2.181-3.247,21.621,21.621,0,0,1-4.327,6.518Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9029",
    "data-name": "Group 9029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9028",
    "data-name": "Group 9028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9027",
    "data-name": "Group 9027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9026",
    "data-name": "Group 9026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9025",
    "data-name": "Group 9025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9024",
    "data-name": "Group 9024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9023",
    "data-name": "Group 9023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6061",
    "data-name": "Path 6061",
    d: "M443.592,312.918a21.081,21.081,0,0,1,.734-5.579,21.081,21.081,0,0,1-.734,5.579Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9036",
    "data-name": "Group 9036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9035",
    "data-name": "Group 9035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9034",
    "data-name": "Group 9034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9033",
    "data-name": "Group 9033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9032",
    "data-name": "Group 9032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9031",
    "data-name": "Group 9031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9030",
    "data-name": "Group 9030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6062",
    "data-name": "Path 6062",
    d: "M436.268,314.09c.111-.021.418,1.43,1.143,3.088s1.557,2.882,1.466,2.948a10.032,10.032,0,0,1-2.609-6.036Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9043",
    "data-name": "Group 9043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9042",
    "data-name": "Group 9042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9041",
    "data-name": "Group 9041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9040",
    "data-name": "Group 9040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9039",
    "data-name": "Group 9039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9038",
    "data-name": "Group 9038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9037",
    "data-name": "Group 9037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6063",
    "data-name": "Path 6063",
    d: "M427.665,315.913c.087-.068,1.157,1.193,2.639,2.58s2.8,2.385,2.737,2.476a15.38,15.38,0,0,1-5.376-5.056Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9050",
    "data-name": "Group 9050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9049",
    "data-name": "Group 9049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9048",
    "data-name": "Group 9048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9047",
    "data-name": "Group 9047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9046",
    "data-name": "Group 9046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9045",
    "data-name": "Group 9045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9044",
    "data-name": "Group 9044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6064",
    "data-name": "Path 6064",
    d: "M430.994,300.288c.108-.018.441,1.57,1.032,3.472s1.2,3.4,1.1,3.451a16,16,0,0,1-2.136-6.923Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9057",
    "data-name": "Group 9057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9056",
    "data-name": "Group 9056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9055",
    "data-name": "Group 9055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9054",
    "data-name": "Group 9054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9053",
    "data-name": "Group 9053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9052",
    "data-name": "Group 9052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9051",
    "data-name": "Group 9051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6065",
    "data-name": "Path 6065",
    d: "M440.9,295.148a20.761,20.761,0,0,1,.34,5.585,20.871,20.871,0,0,1-.34-5.585Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9064",
    "data-name": "Group 9064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9063",
    "data-name": "Group 9063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9062",
    "data-name": "Group 9062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9061",
    "data-name": "Group 9061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9060",
    "data-name": "Group 9060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9059",
    "data-name": "Group 9059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9058",
    "data-name": "Group 9058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6066",
    "data-name": "Path 6066",
    d: "M461.361,308.361a111.091,111.091,0,0,1,4.259.347,6.56,6.56,0,0,1-4.259-.347Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9071",
    "data-name": "Group 9071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9070",
    "data-name": "Group 9070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9069",
    "data-name": "Group 9069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9068",
    "data-name": "Group 9068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9067",
    "data-name": "Group 9067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9066",
    "data-name": "Group 9066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9065",
    "data-name": "Group 9065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6067",
    "data-name": "Path 6067",
    d: "M460.757,303.2a31,31,0,0,1,6.034-3.2,30.915,30.915,0,0,1-6.034,3.2Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9078",
    "data-name": "Group 9078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9077",
    "data-name": "Group 9077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9076",
    "data-name": "Group 9076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9075",
    "data-name": "Group 9075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9074",
    "data-name": "Group 9074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9073",
    "data-name": "Group 9073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9072",
    "data-name": "Group 9072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6068",
    "data-name": "Path 6068",
    d: "M455.225,303.386a19.291,19.291,0,0,1,1.613-5.14,19.26,19.26,0,0,1-1.613,5.14Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9085",
    "data-name": "Group 9085",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9084",
    "data-name": "Group 9084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9083",
    "data-name": "Group 9083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9082",
    "data-name": "Group 9082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9081",
    "data-name": "Group 9081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9080",
    "data-name": "Group 9080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9079",
    "data-name": "Group 9079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6069",
    "data-name": "Path 6069",
    d: "M439.735,367.272a8.854,8.854,0,0,0-3.781-6.947c-2.235-1.5-6.261-1.649-7.843-.523a12.13,12.13,0,0,1,6.881,2.373,19.3,19.3,0,0,1,4.743,5.1"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9092",
    "data-name": "Group 9092",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9091",
    "data-name": "Group 9091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9090",
    "data-name": "Group 9090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9089",
    "data-name": "Group 9089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9088",
    "data-name": "Group 9088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9087",
    "data-name": "Group 9087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9086",
    "data-name": "Group 9086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6070",
    "data-name": "Path 6070",
    d: "M448.49,332.643a7.667,7.667,0,0,0-5.4-4.21c-2.294-.419-5.542.855-6.41,2.295a10.509,10.509,0,0,1,6.286-.494,16.727,16.727,0,0,1,5.528,2.409"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9099",
    "data-name": "Group 9099",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9098",
    "data-name": "Group 9098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9097",
    "data-name": "Group 9097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9096",
    "data-name": "Group 9096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9095",
    "data-name": "Group 9095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9094",
    "data-name": "Group 9094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9093",
    "data-name": "Group 9093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6071",
    "data-name": "Path 6071",
    d: "M454.28,312.049a6.07,6.07,0,0,0,.371-5.234,5.119,5.119,0,0,0-3.735-3c1.78,2.582,3.181,5.2,3.317,8.336"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9106",
    "data-name": "Group 9106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9105",
    "data-name": "Group 9105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9104",
    "data-name": "Group 9104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9103",
    "data-name": "Group 9103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9102",
    "data-name": "Group 9102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9101",
    "data-name": "Group 9101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9100",
    "data-name": "Group 9100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6072",
    "data-name": "Path 6072",
    d: "M418.456,362.62c.02.027-.3.274-.765.824a14.959,14.959,0,0,0-1.717,2.52,27.4,27.4,0,0,0-2.464,9.716,44.308,44.308,0,0,0,.5,10.083c.2,1.282.392,2.315.525,3.029a5.868,5.868,0,0,1,.171,1.119,5.989,5.989,0,0,1-.328-1.084c-.182-.7-.42-1.733-.658-3.015a40.016,40.016,0,0,1-.624-10.164,25.849,25.849,0,0,1,2.622-9.828,12.936,12.936,0,0,1,1.854-2.485A3.013,3.013,0,0,1,418.456,362.62Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9114",
    "data-name": "Group 9114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9113",
    "data-name": "Group 9113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9112",
    "data-name": "Group 9112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9111",
    "data-name": "Group 9111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9110",
    "data-name": "Group 9110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9109",
    "data-name": "Group 9109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9108",
    "data-name": "Group 9108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6073",
    "data-name": "Path 6073",
    d: "M449.591,389.911a.789.789,0,0,1-.2.019l-.6.019-2.3.036-8.473.06-27.952.055-27.62-.054.135-.135c-.014,3.66-.025,6.632-.033,8.72-.012,1.007-.022,1.8-.029,2.37-.007.253-.012.456-.017.617a.835.835,0,0,1-.019.21.926.926,0,0,1-.02-.21l-.021-.616c-.01-.57-.025-1.363-.043-2.371-.021-2.087-.051-5.059-.088-8.719v-.136h.136l27.62-.054,27.952.056,8.473.06,2.3.035.6.019A.85.85,0,0,1,449.591,389.911Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9137",
    "data-name": "Group 9137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9119",
    "data-name": "Group 9119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9116",
    "data-name": "Group 9116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6074",
    "data-name": "Path 6074",
    d: "M98.884,215.614a4.115,4.115,0,1,1-4.115-4.115A4.115,4.115,0,0,1,98.884,215.614Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9118",
    "data-name": "Group 9118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9117",
    "data-name": "Group 9117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6075",
    "data-name": "Path 6075",
    d: "M98.884,215.614c-.049,0-.048-.366-.227-.98a4.106,4.106,0,0,0-1.51-2.145,3.892,3.892,0,1,0,0,6.249,4.1,4.1,0,0,0,1.51-2.144c.179-.614.178-.982.227-.98a2.135,2.135,0,0,1-.03,1.029,4.1,4.1,0,0,1-1.483,2.388,4.285,4.285,0,0,1-4.086.674,4.34,4.34,0,0,1,0-8.182,4.285,4.285,0,0,1,4.085.673,4.1,4.1,0,0,1,1.484,2.388A2.14,2.14,0,0,1,98.884,215.614Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9136",
    "data-name": "Group 9136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9133",
    "data-name": "Group 9133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9132",
    "data-name": "Group 9132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9131",
    "data-name": "Group 9131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9130",
    "data-name": "Group 9130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9129",
    "data-name": "Group 9129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9128",
    "data-name": "Group 9128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9127",
    "data-name": "Group 9127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9126",
    "data-name": "Group 9126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9125",
    "data-name": "Group 9125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9124",
    "data-name": "Group 9124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9123",
    "data-name": "Group 9123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9120",
    "data-name": "Group 9120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6076",
    "data-name": "Path 6076",
    d: "M68.463,220.635A23.538,23.538,0,1,0,42.9,199.314,23.54,23.54,0,0,0,68.463,220.635Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9122",
    "data-name": "Group 9122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9121",
    "data-name": "Group 9121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6077",
    "data-name": "Path 6077",
    d: "M68.463,220.635a2.081,2.081,0,0,1-.38.042l-1.12.07-.827.046c-.3,0-.637-.027-1-.041a16.716,16.716,0,0,1-2.482-.232,22.31,22.31,0,0,1-6.528-1.984A23.7,23.7,0,0,1,43.5,203.661a23.79,23.79,0,0,1-.128-12.523,21.819,21.819,0,0,1,2.668-6.29,21.76,21.76,0,0,1,4.57-5.471,23.022,23.022,0,0,1,6.219-3.984,23.561,23.561,0,0,1,14.957-1.355,23.02,23.02,0,0,1,6.835,2.8,26.84,26.84,0,0,1,2.955,2.078A26.572,26.572,0,0,1,84.1,181.4a21.823,21.823,0,0,1,3.755,5.71,23.782,23.782,0,0,1,2.121,12.344,23.7,23.7,0,0,1-9.756,16.9,22.3,22.3,0,0,1-6.065,3.123,16.744,16.744,0,0,1-2.4.674c-.352.078-.674.166-.974.218l-.821.1-1.115.132a2.013,2.013,0,0,1-.38.027,2.078,2.078,0,0,1,.375-.08l1.1-.183.813-.127c.3-.061.615-.156.963-.242a17.177,17.177,0,0,0,2.368-.715,22.459,22.459,0,0,0,5.961-3.167,23.328,23.328,0,0,0,7.372-28.8,21.439,21.439,0,0,0-3.692-5.583,21.3,21.3,0,0,0-5.371-4.456,22.559,22.559,0,0,0-6.69-2.735,23.074,23.074,0,0,0-14.632,1.325,22.523,22.523,0,0,0-6.088,3.892,21.252,21.252,0,0,0-4.483,5.347,21.415,21.415,0,0,0-2.629,6.154,23.388,23.388,0,0,0,12.421,27.012,22.467,22.467,0,0,0,6.433,2.046,16.973,16.973,0,0,0,2.458.278c.358.023.689.059.991.065l.823-.02,1.119-.019A2.1,2.1,0,0,1,68.463,220.635Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9135",
    "data-name": "Group 9135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9134",
    "data-name": "Group 9134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6078",
    "data-name": "Path 6078",
    d: "M66.393,205.648l-9.563-7.066,2.466-3.337,6.413,4.738,8.748-10.515,3.189,2.654Z",
    fill: "#ff725e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9424",
    "data-name": "Group 9424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9161",
    "data-name": "Group 9161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9138",
    "data-name": "Group 9138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6079",
    "data-name": "Path 6079",
    d: "M73.66,408.167l-5.1,43.242h7.83l14.021-43.242Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9139",
    "data-name": "Group 9139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6080",
    "data-name": "Path 6080",
    d: "M102.254,391.607l-5.1,43.242h7.83l14.021-43.242Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9140",
    "data-name": "Group 9140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6081",
    "data-name": "Path 6081",
    d: "M208.1,408.167l5.558,43.242h-8.536l-15.286-43.242Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9141",
    "data-name": "Group 9141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6082",
    "data-name": "Path 6082",
    d: "M181.534,392.666l5.558,43.242h-8.536l-15.286-43.242Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9144",
    "data-name": "Group 9144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9142",
    "data-name": "Group 9142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6083",
    "data-name": "Path 6083",
    d: "M97.085,249.156s-21.4,1.512-35.745,8.9c-11.265,5.8-16.737,13.926-18.949,34.363S25.809,317.052,25.44,324.049c-.359,6.826,3.14,36.015,28.3,94.43a7.323,7.323,0,0,0,6.727,4.42h87.2V247.788Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9143",
    "data-name": "Group 9143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6084",
    "data-name": "Path 6084",
    d: "M180.175,249.156s21.4,1.512,35.746,8.9c11.264,5.8,16.737,13.926,18.948,34.363s16.583,24.634,16.951,31.631c.361,6.849-3.163,36.213-28.554,95.026a6.339,6.339,0,0,1-5.817,3.824H129.6V247.788Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9146",
    "data-name": "Group 9146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9145",
    "data-name": "Group 9145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6085",
    "data-name": "Path 6085",
    d: "M201.75,393.53a8.474,8.474,0,0,1,1.548-.287,14.3,14.3,0,0,1,4.295.195,11.015,11.015,0,0,1,5.579,3.062,17.644,17.644,0,0,1,3.916,6.749,38.027,38.027,0,0,1,1.674,7.615c.3,2.377.42,4.53.475,6.336s.045,3.268.021,4.277a8.866,8.866,0,0,1-.094,1.567,9.307,9.307,0,0,1-.109-1.565c-.038-1.008-.086-2.466-.186-4.263s-.259-3.936-.582-6.289a39.636,39.636,0,0,0-1.691-7.508,17.576,17.576,0,0,0-3.767-6.583,10.85,10.85,0,0,0-5.318-3.039A20.617,20.617,0,0,0,201.75,393.53Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9148",
    "data-name": "Group 9148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9147",
    "data-name": "Group 9147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6086",
    "data-name": "Path 6086",
    d: "M210.457,368.643c0,.144-32.373.26-72.3.26s-72.305-.116-72.305-.26,32.366-.26,72.305-.26S210.457,368.5,210.457,368.643Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9150",
    "data-name": "Group 9150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9149",
    "data-name": "Group 9149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6087",
    "data-name": "Path 6087",
    d: "M72.251,392.289a8.3,8.3,0,0,1-1.488.173c-.479.029-1.05.176-1.72.279-.334.056-.676.186-1.046.284a6.375,6.375,0,0,0-1.143.4,11.654,11.654,0,0,0-4.719,3.505,17.416,17.416,0,0,0-3.113,6.552,34.268,34.268,0,0,0-1,7.28,54.5,54.5,0,0,0,.1,6.03c.12,1.715.281,3.1.4,4.054a10.737,10.737,0,0,1,.157,1.491,6.675,6.675,0,0,1-.357-1.459c-.18-.95-.4-2.333-.565-4.056a48.264,48.264,0,0,1-.218-6.076,33.075,33.075,0,0,1,.979-7.4,17.422,17.422,0,0,1,3.246-6.723,11.735,11.735,0,0,1,4.956-3.545,6.412,6.412,0,0,1,1.186-.377c.383-.088.737-.207,1.08-.25.688-.079,1.274-.2,1.76-.2A8.2,8.2,0,0,1,72.251,392.289Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9152",
    "data-name": "Group 9152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9151",
    "data-name": "Group 9151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6088",
    "data-name": "Path 6088",
    d: "M72.251,392.289a.955.955,0,0,1-.1-.232c-.07-.187-.155-.417-.26-.7-.226-.616-.553-1.529-.908-2.724-.752-2.379-1.7-5.859-2.833-10.169-1.112-4.328-2.431-9.461-3.895-15.156-1.48-5.7-3.115-11.965-5.093-18.459a98.623,98.623,0,0,0-3.293-9.326,19.356,19.356,0,0,0-1-2.138c-.339-.7-.719-1.375-1.117-2.041-.768-1.339-1.5-2.657-2.269-3.9a19.749,19.749,0,0,0-5.41-6.173,15.831,15.831,0,0,0-6.671-2.51,18.434,18.434,0,0,0-10.22,1.473,23.282,23.282,0,0,0-3.317,1.952c-.006-.007.057-.066.186-.174l.583-.469a15.717,15.717,0,0,1,2.461-1.492,18.294,18.294,0,0,1,10.356-1.655,16.121,16.121,0,0,1,6.867,2.519,20.1,20.1,0,0,1,5.573,6.276c.782,1.257,1.522,2.576,2.292,3.909.4.657.779,1.336,1.132,2.054a19.644,19.644,0,0,1,1.024,2.17,97.056,97.056,0,0,1,3.323,9.376c1.983,6.511,3.6,12.784,5.06,18.493,1.423,5.706,2.705,10.848,3.787,15.184,1.086,4.319,1.979,7.811,2.671,10.2.324,1.2.619,2.122.812,2.749.085.29.155.525.211.716A.95.95,0,0,1,72.251,392.289Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9154",
    "data-name": "Group 9154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9153",
    "data-name": "Group 9153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6089",
    "data-name": "Path 6089",
    d: "M185.7,349.581s-.3.017-.895.024l-2.628.017-10.1.016-37.161-.039-25.662-.052-14.3-.093c-2.454.005-4.949.006-7.461.129a11.44,11.44,0,0,0-1.825.2,12.476,12.476,0,0,0-1.7.785c-1.118.6-2.217,1.269-3.307,1.963-2.177,1.393-4.322,2.9-6.428,4.508a58.615,58.615,0,0,0-6.07,5.232,13.156,13.156,0,0,0-2.433,3.161,2.459,2.459,0,0,0-.241.887,5.228,5.228,0,0,0,.184.95l.49,2.011c.667,2.687,1.369,5.393,2.088,8.121q1.1,4.083,2.226,8.239.592,2.065,1.19,4.149c.207.69.418,1.385.658,2.051.03.093.057.122.079.188.012.022.021.076.032.074s0-.023.008-.016c.166.025.331.052.513.066.353.037.718.056,1.078.08,5.808.277,11.728.33,17.709.423,23.941.287,46.753.31,67.5.265,10.373-.031,20.23-.088,29.453-.212,4.611-.066,9.065-.139,13.34-.3,1.068-.043,2.126-.089,3.166-.169.26-.018.518-.043.772-.074.13-.011.246-.038.367-.058a.373.373,0,0,0,.237-.137,4.453,4.453,0,0,0,.71-1.279,48.784,48.784,0,0,0,1.748-5.729c.962-3.8,1.739-7.451,2.463-10.908q.269-1.3.529-2.558a9.59,9.59,0,0,0,.35-2.452,8.581,8.581,0,0,0-2.182-4.137,45.46,45.46,0,0,0-6.385-5.825c-2.1-1.642-4.076-3.071-5.841-4.375a33.865,33.865,0,0,0-4.788-3.286,16.951,16.951,0,0,0-6.589-1.791c-.295-.027-.519-.024-.668-.035s-.226-.018-.226-.018.3-.02.9,0a15.6,15.6,0,0,1,2.612.315,16.43,16.43,0,0,1,4.045,1.39,33.738,33.738,0,0,1,4.838,3.261c1.773,1.291,3.758,2.709,5.873,4.343a45.5,45.5,0,0,1,6.455,5.833,8.828,8.828,0,0,1,2.27,4.293,9.709,9.709,0,0,1-.345,2.548q-.256,1.262-.519,2.561c-.712,3.462-1.478,7.12-2.431,10.931a48.924,48.924,0,0,1-1.749,5.787,4.682,4.682,0,0,1-.793,1.408.787.787,0,0,1-.424.242c-.135.023-.274.053-.4.064-.264.034-.528.059-.79.079-1.052.083-2.111.131-3.182.178-4.283.167-8.737.25-13.35.326-9.226.143-19.083.215-29.457.26-20.748.072-43.56.062-67.507-.224-5.986-.094-11.9-.147-17.733-.427-.366-.024-.729-.043-1.1-.082-.181-.014-.375-.043-.568-.075a1.025,1.025,0,0,1-.249-.106c-.061-.047-.067-.1-.1-.153a2.342,2.342,0,0,1-.144-.308c-.253-.7-.461-1.392-.67-2.088q-.6-2.088-1.191-4.159-1.121-4.158-2.224-8.247-1.076-4.1-2.083-8.129l-.49-2.017a5.284,5.284,0,0,1-.2-1.074,2.946,2.946,0,0,1,.287-1.086,13.506,13.506,0,0,1,2.534-3.3,59.2,59.2,0,0,1,6.128-5.273q3.178-2.42,6.468-4.523c1.1-.7,2.2-1.367,3.341-1.978a12.925,12.925,0,0,1,1.772-.814,11.227,11.227,0,0,1,1.948-.221C90,348.993,92.5,349,94.957,349l14.3.118,25.661.116,37.161.2,10.1.082,2.628.034C185.4,349.562,185.7,349.581,185.7,349.581Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9156",
    "data-name": "Group 9156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9155",
    "data-name": "Group 9155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6090",
    "data-name": "Path 6090",
    d: "M207.312,392.289a.9.9,0,0,1,.052-.25l.2-.714c.186-.624.471-1.54.758-2.745.633-2.391,1.388-5.895,2.28-10.231l3.05-15.256c1.173-5.738,2.469-12.05,4.193-18.6a78.032,78.032,0,0,1,3.065-9.41c.323-.735.71-1.44,1.057-2.15.367-.7.8-1.346,1.2-2a42.177,42.177,0,0,1,2.611-3.691,24.147,24.147,0,0,1,6.157-5.643,17.2,17.2,0,0,1,6.861-2.412,18.292,18.292,0,0,1,10.293,1.673,15.773,15.773,0,0,1,2.445,1.486l.58.467a.947.947,0,0,1,.186.173,23.792,23.792,0,0,0-3.3-1.943,18.43,18.43,0,0,0-10.157-1.491,16.935,16.935,0,0,0-6.683,2.414,23.891,23.891,0,0,0-6.008,5.574,42.34,42.34,0,0,0-2.567,3.659c-.4.65-.825,1.3-1.182,1.986-.336.7-.71,1.379-1.026,2.1a79.094,79.094,0,0,0-3.031,9.343c-1.718,6.525-3.028,12.83-4.226,18.559s-2.221,10.906-3.159,15.236-1.75,7.826-2.446,10.208c-.317,1.2-.635,2.11-.854,2.725-.1.283-.184.513-.251.7A.943.943,0,0,1,207.312,392.289Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9158",
    "data-name": "Group 9158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9157",
    "data-name": "Group 9157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6091",
    "data-name": "Path 6091",
    d: "M209.659,263.62c.139.034-4.424,19.322-10.191,43.075s-10.559,42.99-10.7,42.956,4.423-19.317,10.193-43.079S209.519,263.586,209.659,263.62Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9160",
    "data-name": "Group 9160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9159",
    "data-name": "Group 9159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6092",
    "data-name": "Path 6092",
    d: "M66.481,269.763a5.057,5.057,0,0,1,.285.793q.267.857.718,2.3l2.534,8.5c2.108,7.189,4.953,17.14,7.992,28.159S83.7,330.549,85.576,337.8c.911,3.594,1.653,6.519,2.18,8.6q.354,1.473.563,2.345a5.117,5.117,0,0,1,.163.827,4.966,4.966,0,0,1-.264-.8q-.245-.864-.658-2.321L85.22,337.9c-1.985-7.269-4.706-17.23-7.712-28.238-3.057-10.989-5.825-20.936-7.844-28.2-.992-3.572-1.8-6.479-2.375-8.547q-.392-1.464-.624-2.331A5.187,5.187,0,0,1,66.481,269.763Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9219",
    "data-name": "Group 9219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9218",
    "data-name": "Group 9218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9169",
    "data-name": "Group 9169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9162",
    "data-name": "Group 9162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6093",
    "data-name": "Path 6093",
    d: "M105.553,153.654a6.128,6.128,0,0,1,5.647-5.583c-1.7-2.788-.276-6.82,2.61-8.353a8.242,8.242,0,0,1,9.091,1.443,6.3,6.3,0,0,1,11.689,3.471c2.652-.849,5.646,1.332,6.173,4.066a7.436,7.436,0,0,1-3.3,7.177c1.356,1.023,1.217,3.255.11,4.544a7.582,7.582,0,0,1-4.517,2.136l-10.539,3.125c-2.529,1.414-5.639,2.126-8.344,1.087s-4.648-4.229-3.626-6.94A6.128,6.128,0,0,1,105.553,153.654Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9164",
    "data-name": "Group 9164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9163",
    "data-name": "Group 9163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6094",
    "data-name": "Path 6094",
    d: "M105.645,152.465a1.678,1.678,0,0,1,.368-.358,4.216,4.216,0,0,1,1.324-.666,4.968,4.968,0,0,1,2.361-.106,4.56,4.56,0,0,1,2.715,1.6l-.317.1a6.274,6.274,0,0,1,1.659-3.829,8.008,8.008,0,0,1,4.232-2.435,9.291,9.291,0,0,1,5.416.607,13.478,13.478,0,0,1,4.792,3.414,6.435,6.435,0,0,1,1.484,2.506,3.358,3.358,0,0,1-.425,2.831,2.718,2.718,0,0,1-1.093.958,2.182,2.182,0,0,1-1.444.126,2.715,2.715,0,0,1-1.858-1.913,3.13,3.13,0,0,1,.475-2.486,4.091,4.091,0,0,1,1.823-1.509,7.279,7.279,0,0,1,4.125-.338,9.365,9.365,0,0,1,5.169,2.84,8.1,8.1,0,0,1,.98,1.287,2.359,2.359,0,0,1,.253.5,17.613,17.613,0,0,0-1.378-1.651,9.445,9.445,0,0,0-5.087-2.617,6.964,6.964,0,0,0-3.886.369,3.653,3.653,0,0,0-1.614,1.364,2.672,2.672,0,0,0-.4,2.111,2.237,2.237,0,0,0,1.519,1.557,1.852,1.852,0,0,0,1.99-.887,2.837,2.837,0,0,0,.349-2.408,5.972,5.972,0,0,0-1.373-2.3c-2.6-2.89-6.43-4.585-9.724-3.9a7.615,7.615,0,0,0-4.015,2.254,5.951,5.951,0,0,0-1.619,3.565l-.038.463-.279-.366a4.308,4.308,0,0,0-2.491-1.547,4.9,4.9,0,0,0-2.253.02A5.619,5.619,0,0,0,105.645,152.465Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9166",
    "data-name": "Group 9166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9165",
    "data-name": "Group 9165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6095",
    "data-name": "Path 6095",
    d: "M115.428,163.336c.011.005-.021.1-.105.266a2.318,2.318,0,0,1-.543.629,2.781,2.781,0,0,1-1.224.555,2.551,2.551,0,0,1-1.8-.309l-.96-.585,1.082.326,1.141.344,1.42.427-1.483-.112a2.858,2.858,0,0,1-1.787-4.868l.335.281a6.162,6.162,0,0,1-10.914-1.814,5.836,5.836,0,0,1,.424-4.86,3.109,3.109,0,0,1,4.21-1.225l-.286.387a4.41,4.41,0,0,1-1.474-2.989,4.892,4.892,0,0,1,.671-2.954,3.887,3.887,0,0,1,2.1-1.665,4.692,4.692,0,0,1,5.014,1.476,2.709,2.709,0,0,1,.532,1.005c-.04.02-.177-.363-.652-.9a4.541,4.541,0,0,0-2.661-1.42,4.287,4.287,0,0,0-2.119.177,3.533,3.533,0,0,0-1.872,1.541,4.5,4.5,0,0,0-.571,2.7,3.972,3.972,0,0,0,1.337,2.661l-.287.387a2.623,2.623,0,0,0-3.514,1.092,5.357,5.357,0,0,0-.362,4.424,5.7,5.7,0,0,0,10.059,1.729l.336.281a2.518,2.518,0,0,0-.513,2.784,2.576,2.576,0,0,0,2.019,1.45l-.064.315-1.131-.376.123-.26a2.345,2.345,0,0,0,1.6.331,2.726,2.726,0,0,0,1.167-.457A3.629,3.629,0,0,0,115.428,163.336Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9168",
    "data-name": "Group 9168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9167",
    "data-name": "Group 9167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6096",
    "data-name": "Path 6096",
    d: "M145.331,157.14a13.142,13.142,0,0,0,.888-1.307,6.156,6.156,0,0,0,.62-4.116,5.776,5.776,0,0,0-4.077-4.295,5.538,5.538,0,0,0-1.763-.213,1.924,1.924,0,0,0-1.524.654.828.828,0,0,0,.281,1.31,2.51,2.51,0,0,0,1.823-.146,4.867,4.867,0,0,0,2.732-2.613,3.966,3.966,0,0,0-.257-3.461,5.908,5.908,0,0,0-5.155-2.943,6.226,6.226,0,0,0-3.916,1.422c-.781.648-1.085,1.143-1.126,1.111a1.142,1.142,0,0,1,.2-.364,5.316,5.316,0,0,1,.789-.9,6.231,6.231,0,0,1,4.045-1.637,6.469,6.469,0,0,1,3,.665,5.913,5.913,0,0,1,2.579,2.415,4.441,4.441,0,0,1,.31,3.884,5.354,5.354,0,0,1-3.016,2.906,2.98,2.98,0,0,1-2.219.136,1.281,1.281,0,0,1-.772-.94,1.534,1.534,0,0,1,.281-1.138,2.4,2.4,0,0,1,1.917-.858,6,6,0,0,1,1.923.249,6.012,6.012,0,0,1,3.5,8.973,5.094,5.094,0,0,1-.738.944C145.454,157.064,145.343,157.153,145.331,157.14Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9170",
    "data-name": "Group 9170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6097",
    "data-name": "Path 6097",
    d: "M113.648,165.572c1.188-2.273,4.46-2.563,6.818-1.552a4.641,4.641,0,0,1,7.2-4.412c.563.38,1.12.91,1.8.865.711-.048,1.2-.7,1.715-1.193a4.694,4.694,0,1,1,6.008,7.188l-.323-1.251a26.563,26.563,0,0,1-14.432,7.023,10.18,10.18,0,0,1-6.659-.838C113.812,170.238,112.591,167.6,113.648,165.572Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9171",
    "data-name": "Group 9171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6098",
    "data-name": "Path 6098",
    d: "M107.858,185.627a8.471,8.471,0,0,1,.385-9.779,8.078,8.078,0,0,1,3.23-2.376,10.163,10.163,0,0,1,2.319-5.889c2.1-2.355,6.123-3.125,8.43-.975a7.665,7.665,0,0,1,10.51-3.223c3.041-3.551,9.427-3.322,12.205.438a5.667,5.667,0,0,1,8.789,5.566,6.19,6.19,0,0,1,6.792,8.32,4.578,4.578,0,0,1,2.716,8.046,6.5,6.5,0,0,1-1.38,9.368,5.41,5.41,0,0,1-3.616,6.226l-37.8,11.238c-6.351-.451-8.072-4.58-8.331-8.42a5.808,5.808,0,0,1-3.194-8.248,6.514,6.514,0,0,1-1.051-10.292Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9203",
    "data-name": "Group 9203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9172",
    "data-name": "Group 9172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6099",
    "data-name": "Path 6099",
    d: "M122.622,177.108l23.192-5.147c7.4-.565,12.033,8.657,12.284,16.07.278,8.236.292,18.3-.861,24.408-2.319,12.276-11.818,13.57-11.818,13.57,0-.042-.035.183-.212,3.845l-.167,5.942a10.282,10.282,0,0,1-2.461,6.568c-3.651,4.114-9.8,4.275-16.823,1.114-4.07-1.832-3.817-4.14-4.316-9.82l-3.3-53.688A6.425,6.425,0,0,1,122.622,177.108Z",
    fill: "#c17560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9175",
    "data-name": "Group 9175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9174",
    "data-name": "Group 9174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9173",
    "data-name": "Group 9173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6100",
    "data-name": "Path 6100",
    d: "M153.257,199.154a1.582,1.582,0,0,1-1.572,1.551,1.513,1.513,0,0,1-1.589-1.474,1.583,1.583,0,0,1,1.57-1.552A1.516,1.516,0,0,1,153.257,199.154Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9178",
    "data-name": "Group 9178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9177",
    "data-name": "Group 9177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9176",
    "data-name": "Group 9176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6101",
    "data-name": "Path 6101",
    d: "M155.208,194.354c-.2.2-1.375-.721-3.077-.767-1.7-.07-2.975.77-3.154.556-.088-.1.123-.461.678-.842a4.352,4.352,0,0,1,2.532-.7,4.17,4.17,0,0,1,2.442.868C155.14,193.886,155.307,194.264,155.208,194.354Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9181",
    "data-name": "Group 9181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9180",
    "data-name": "Group 9180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9179",
    "data-name": "Group 9179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6102",
    "data-name": "Path 6102",
    d: "M138.475,198.668a1.582,1.582,0,0,1-1.572,1.551,1.514,1.514,0,0,1-1.589-1.474,1.584,1.584,0,0,1,1.571-1.552A1.515,1.515,0,0,1,138.475,198.668Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9184",
    "data-name": "Group 9184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9183",
    "data-name": "Group 9183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9182",
    "data-name": "Group 9182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6103",
    "data-name": "Path 6103",
    d: "M139.114,194.354c-.2.2-1.377-.721-3.078-.766-1.7-.07-2.975.769-3.153.555-.088-.1.121-.461.678-.841a4.343,4.343,0,0,1,2.532-.7,4.176,4.176,0,0,1,2.441.868C139.044,193.886,139.212,194.264,139.114,194.354Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9187",
    "data-name": "Group 9187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9186",
    "data-name": "Group 9186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9185",
    "data-name": "Group 9185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6104",
    "data-name": "Path 6104",
    d: "M143.921,205.76a11.286,11.286,0,0,1,2.779-.419c.436-.032.85-.106.932-.4a2.208,2.208,0,0,0-.252-1.3l-1.189-3.347c-1.648-4.765-2.826-8.678-2.634-8.742s1.684,3.745,3.331,8.509c.4,1.175.775,2.294,1.134,3.366a2.509,2.509,0,0,1,.176,1.712,1.093,1.093,0,0,1-.733.615,2.966,2.966,0,0,1-.742.081A11.1,11.1,0,0,1,143.921,205.76Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9190",
    "data-name": "Group 9190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9189",
    "data-name": "Group 9189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9188",
    "data-name": "Group 9188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6105",
    "data-name": "Path 6105",
    d: "M145.468,226.012a31.393,31.393,0,0,1-16.39-4.888s3.832,8.75,16.21,7.956Z",
    fill: "#6f4439"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9192",
    "data-name": "Group 9192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9191",
    "data-name": "Group 9191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6106",
    "data-name": "Path 6106",
    d: "M138.157,209.154a2.467,2.467,0,0,1,2.084-1.058,3.208,3.208,0,0,1,2.882,1.534,1.993,1.993,0,0,1,.088,1.444c-.115.242-.028.124-.222.286a5.62,5.62,0,0,1-2.337,1.357,2.411,2.411,0,0,1-2.517-1.011A2.459,2.459,0,0,1,138.157,209.154Z",
    fill: "#6f4439"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9195",
    "data-name": "Group 9195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9194",
    "data-name": "Group 9194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9193",
    "data-name": "Group 9193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6107",
    "data-name": "Path 6107",
    d: "M138.568,206.843c.277-.009.238,1.839,1.788,3.187s3.523,1.192,3.531,1.451c.023.116-.447.349-1.279.351a4.592,4.592,0,0,1-2.949-1.1,4.012,4.012,0,0,1-1.382-2.67C138.225,207.283,138.442,206.83,138.568,206.843Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9198",
    "data-name": "Group 9198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9197",
    "data-name": "Group 9197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9196",
    "data-name": "Group 9196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6108",
    "data-name": "Path 6108",
    d: "M139.362,186.933c-.155.467-1.861.3-3.851.594-2,.257-3.59.887-3.867.48-.124-.2.144-.639.783-1.105a6.774,6.774,0,0,1,5.88-.819C139.048,186.358,139.428,186.711,139.362,186.933Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9201",
    "data-name": "Group 9201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9200",
    "data-name": "Group 9200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9199",
    "data-name": "Group 9199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6109",
    "data-name": "Path 6109",
    d: "M154.873,188.282c-.355.367-1.642-.1-3.214-.21-1.569-.153-2.92.1-3.205-.319-.124-.2.107-.579.71-.913a4.85,4.85,0,0,1,2.649-.49,4.8,4.8,0,0,1,2.522.916C154.87,187.693,155.031,188.1,154.873,188.282Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9202",
    "data-name": "Group 9202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6110",
    "data-name": "Path 6110",
    d: "M145.984,170.64c.015.09.026.181.04.271l-.044.015C145.982,170.831,145.983,170.736,145.984,170.64Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9205",
    "data-name": "Group 9205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9204",
    "data-name": "Group 9204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6111",
    "data-name": "Path 6111",
    d: "M121.422,199.114a1.609,1.609,0,0,0-1.271-1.677c-1.992-.423-5.523-.43-5.874,4.582-.485,6.934,6.577,5.99,6.6,5.792C120.9,207.658,121.26,201.763,121.422,199.114Z",
    fill: "#c17560"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9207",
    "data-name": "Group 9207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9206",
    "data-name": "Group 9206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6112",
    "data-name": "Path 6112",
    d: "M118.946,205.036c-.029-.024-.127.076-.338.156a1.209,1.209,0,0,1-.9-.045,3,3,0,0,1-1.2-2.778,4,4,0,0,1,.46-1.706,1.4,1.4,0,0,1,.973-.863.616.616,0,0,1,.69.381c.079.2.025.335.061.35.019.018.157-.106.121-.4a.77.77,0,0,0-.242-.454.914.914,0,0,0-.656-.223,1.7,1.7,0,0,0-1.337.987,4.118,4.118,0,0,0-.554,1.9c-.053,1.4.571,2.758,1.553,3.117a1.3,1.3,0,0,0,1.118-.106C118.921,205.2,118.969,205.051,118.946,205.036Z",
    fill: "#6f4439"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9208",
    "data-name": "Group 9208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6113",
    "data-name": "Path 6113",
    d: "M160.542,192.127a4.3,4.3,0,0,1-4.3-5.189,4.484,4.484,0,0,1-4.418-5.684,5.572,5.572,0,0,1-7.886-3.755,1.617,1.617,0,0,1-.877,1.343,2.955,2.955,0,0,1-1.634.288,5.226,5.226,0,0,1-4.316-3.037,4.691,4.691,0,0,1-5.719,1.837c-.735-.323-1.449-1.006-1.325-1.8a2.086,2.086,0,0,1,.361-.794c2.1-3.19,5.934-4.946,9.741-5.281A27.8,27.8,0,0,1,151.4,171.87a14.856,14.856,0,0,1,5.875,3.175c1.715,1.708,2.594,4.059,3.424,6.332a27.38,27.38,0,0,1,1.487,5.064,9.167,9.167,0,0,1-.526,5.185l-.478.041",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9209",
    "data-name": "Group 9209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6114",
    "data-name": "Path 6114",
    d: "M131.393,176a6.523,6.523,0,0,1-5.374,6.2,3.233,3.233,0,0,1-1.777,6.2,7.9,7.9,0,0,1,.805,3.148,2.694,2.694,0,0,1-1.68,2.562,3.112,3.112,0,0,1,.8,2.728,2.57,2.57,0,0,1-2.521,1.977c-1.032,0-1.847-1.253-2.861-1.444a4.884,4.884,0,0,0-4.249,1.288l-1.273-12.933,1.566-10.365,6.052-4.426,11.666,2.085Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9211",
    "data-name": "Group 9211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9210",
    "data-name": "Group 9210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6115",
    "data-name": "Path 6115",
    d: "M111.972,176.357a8.458,8.458,0,0,0,1.225-.136,3.362,3.362,0,0,0,2.314-2.037l.287-.772.115.819a3.987,3.987,0,0,0,1.488,2.535,3.708,3.708,0,0,0,3.282.657,3.846,3.846,0,0,0,1.92-1.166l.224-.257.183.286a5.4,5.4,0,0,0,2.654,2.126,5.312,5.312,0,0,0,2.737.246,8.51,8.51,0,0,0,2.373-.909c.017.02-.148.207-.523.466a5.163,5.163,0,0,1-1.787.766,5.42,5.42,0,0,1-2.948-.152,5.717,5.717,0,0,1-2.934-2.268l.406.029a4.29,4.29,0,0,1-2.172,1.336,4.158,4.158,0,0,1-3.722-.775,4.333,4.333,0,0,1-1.594-2.87l.4.047a3.52,3.52,0,0,1-2.656,2.124A1.987,1.987,0,0,1,111.972,176.357Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9213",
    "data-name": "Group 9213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9212",
    "data-name": "Group 9212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6116",
    "data-name": "Path 6116",
    d: "M130.148,162.787a25.537,25.537,0,0,0-2.57,1.408,5.36,5.36,0,0,0-1.9,2.385,3.314,3.314,0,0,0,.54,3.434,2.553,2.553,0,0,0,1.012.7l.305.113-.176.271a3.242,3.242,0,0,0-.051,3.072,5.788,5.788,0,0,0,1.695,2.042c1.223.945,2.074,1.406,2.027,1.479-.016.028-.239-.06-.629-.253a12.088,12.088,0,0,1-1.607-.952,5.815,5.815,0,0,1-1.9-2.121,3.658,3.658,0,0,1,.033-3.549l.13.384a3.032,3.032,0,0,1-1.226-.836,3.758,3.758,0,0,1-.6-3.956,5.53,5.53,0,0,1,2.132-2.513,8.146,8.146,0,0,1,1.992-.936A2.053,2.053,0,0,1,130.148,162.787Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9215",
    "data-name": "Group 9215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9214",
    "data-name": "Group 9214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6117",
    "data-name": "Path 6117",
    d: "M167.784,204.187c.006.017-.076.062-.242.133a3,3,0,0,1-.769.176,3.929,3.929,0,0,1-2.764-.811,3.933,3.933,0,0,1,.18-6.168,2.43,2.43,0,0,1,1.369-.475,1.724,1.724,0,0,1,1.391.669,1.5,1.5,0,0,1,.09,1.551,2.518,2.518,0,0,1-.995,1.05,3.7,3.7,0,0,1-2.591.339,4.5,4.5,0,0,1-2.076-1.092,4.6,4.6,0,0,1-1.118-1.7,5.6,5.6,0,0,1-.269-2.87,2.525,2.525,0,0,1,.307-1.008,10.177,10.177,0,0,1-.106,1.031,5.877,5.877,0,0,0,.41,2.71,4.321,4.321,0,0,0,1.067,1.518,4.117,4.117,0,0,0,1.884.941,3.261,3.261,0,0,0,2.233-.308c.653-.365,1.2-1.253.743-1.856a1.218,1.218,0,0,0-.969-.456,1.929,1.929,0,0,0-1.079.375A3.354,3.354,0,0,0,163.2,199.8a3.42,3.42,0,0,0,1.045,3.6,3.9,3.9,0,0,0,2.522.9C167.417,204.286,167.769,204.139,167.784,204.187Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9217",
    "data-name": "Group 9217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9216",
    "data-name": "Group 9216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6118",
    "data-name": "Path 6118",
    d: "M113.215,195.471a2.518,2.518,0,0,1-.895.48,7.636,7.636,0,0,1-2.734.47,10.981,10.981,0,0,1-4.06-.754,3.138,3.138,0,0,1-1.769-1.806,2.013,2.013,0,0,1,.02-1.423,1.888,1.888,0,0,1,1.072-1.02,1.469,1.469,0,0,1,.912-.031l-.186.483a4.236,4.236,0,0,1-2.266-4.143,3.64,3.64,0,0,1,.8-1.987,4.119,4.119,0,0,1,1.476-1.111,4.008,4.008,0,0,1,2.588-.264,1.833,1.833,0,0,1,.864.391c-.019.043-.321-.11-.9-.2a4.062,4.062,0,0,0-2.4.395,3.4,3.4,0,0,0-1.959,2.814A3.8,3.8,0,0,0,105.8,191.4l-.187.484a.955.955,0,0,0-.586.025,1.377,1.377,0,0,0-.771.733,1.523,1.523,0,0,0-.012,1.059,2.676,2.676,0,0,0,1.487,1.531,11.329,11.329,0,0,0,3.864.821A10.161,10.161,0,0,0,113.215,195.471Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9220",
    "data-name": "Group 9220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6119",
    "data-name": "Path 6119",
    d: "M160.88,288.329c.314.472,11.474,15.462,11.474,15.462l13.5-12.537-8.64-21.771-5.185-8.877Z",
    fill: "#c17560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9221",
    "data-name": "Group 9221",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6120",
    "data-name": "Path 6120",
    d: "M116.945,422.9l-5.637-.112-2-48.951-12.233-5.193,22.232-13.692,59.3,41.914L190.442,422.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9300",
    "data-name": "Group 9300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9222",
    "data-name": "Group 9222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6121",
    "data-name": "Path 6121",
    d: "M156.014,406.077c-.043.023,10.46,19.824,10.46,19.824l15.537-8.653-6.829-21.6Z",
    fill: "#c17560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9299",
    "data-name": "Group 9299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9298",
    "data-name": "Group 9298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9232",
    "data-name": "Group 9232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9231",
    "data-name": "Group 9231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9230",
    "data-name": "Group 9230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9229",
    "data-name": "Group 9229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9228",
    "data-name": "Group 9228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9227",
    "data-name": "Group 9227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9226",
    "data-name": "Group 9226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9225",
    "data-name": "Group 9225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9224",
    "data-name": "Group 9224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9223",
    "data-name": "Group 9223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6122",
    "data-name": "Path 6122",
    d: "M164.712,423.206s15.973.49,16.322-9.812l.855,2.072,23.86,15.687c3.8,2.7,3.493,5.79,2.492,7.373a3.618,3.618,0,0,1-3.525,1.679c-7.421-.948-34.7-4.568-36.076-6.767l-1.421-1.919c-2.274-2.693-3.024-6-2.262-7.2Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9242",
    "data-name": "Group 9242",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9241",
    "data-name": "Group 9241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9240",
    "data-name": "Group 9240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9239",
    "data-name": "Group 9239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9238",
    "data-name": "Group 9238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9237",
    "data-name": "Group 9237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9236",
    "data-name": "Group 9236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9235",
    "data-name": "Group 9235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9234",
    "data-name": "Group 9234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9233",
    "data-name": "Group 9233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6123",
    "data-name": "Path 6123",
    d: "M207.831,439.061l-40.612-7.542.892,1.2c.848,1.393,1.8,1.491,3.038,1.873,3.668,1.132,12.855,2.946,33.482,5.673a3.62,3.62,0,0,0,3.2-1.209Z",
    fill: "#fff"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9253",
    "data-name": "Group 9253",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9252",
    "data-name": "Group 9252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9251",
    "data-name": "Group 9251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9250",
    "data-name": "Group 9250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9249",
    "data-name": "Group 9249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9248",
    "data-name": "Group 9248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9247",
    "data-name": "Group 9247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9246",
    "data-name": "Group 9246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9245",
    "data-name": "Group 9245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9244",
    "data-name": "Group 9244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9243",
    "data-name": "Group 9243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6124",
    "data-name": "Path 6124",
    d: "M170.062,426.356a2.194,2.194,0,0,1,2.187,1.945,2.109,2.109,0,0,1-1.908,2.185,2.315,2.315,0,0,1-2.306-2.071c.042-1.077,1.179-2.259,2.237-2.053",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9264",
    "data-name": "Group 9264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9263",
    "data-name": "Group 9263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9262",
    "data-name": "Group 9262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9261",
    "data-name": "Group 9261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9260",
    "data-name": "Group 9260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9259",
    "data-name": "Group 9259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9258",
    "data-name": "Group 9258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9257",
    "data-name": "Group 9257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9256",
    "data-name": "Group 9256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9255",
    "data-name": "Group 9255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9254",
    "data-name": "Group 9254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6125",
    "data-name": "Path 6125",
    d: "M188.862,429.549c.219-.041-.242-2.005.855-4.058,1.036-2.086,2.9-2.849,2.81-3.051-.027-.088-.551-.042-1.285.357a5.775,5.775,0,0,0-2.835,5.5C188.508,429.125,188.775,429.578,188.862,429.549Z",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9275",
    "data-name": "Group 9275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9274",
    "data-name": "Group 9274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9273",
    "data-name": "Group 9273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9272",
    "data-name": "Group 9272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9271",
    "data-name": "Group 9271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9270",
    "data-name": "Group 9270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9269",
    "data-name": "Group 9269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9268",
    "data-name": "Group 9268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9267",
    "data-name": "Group 9267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9266",
    "data-name": "Group 9266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9265",
    "data-name": "Group 9265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6126",
    "data-name": "Path 6126",
    d: "M193.392,431.247c.226.023.454-1.577,1.612-3.088,1.125-1.536,2.6-2.2,2.512-2.414-.026-.206-1.841.205-3.134,1.949C193.072,429.423,193.187,431.28,193.392,431.247Z",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9286",
    "data-name": "Group 9286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9285",
    "data-name": "Group 9285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9284",
    "data-name": "Group 9284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9283",
    "data-name": "Group 9283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9282",
    "data-name": "Group 9282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9281",
    "data-name": "Group 9281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9280",
    "data-name": "Group 9280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9279",
    "data-name": "Group 9279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9278",
    "data-name": "Group 9278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9277",
    "data-name": "Group 9277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9276",
    "data-name": "Group 9276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6127",
    "data-name": "Path 6127",
    d: "M183.73,427.672c.2.031.5-2.105,1.879-4.279,1.351-2.2,3.143-3.393,3.026-3.561-.057-.161-2.143.853-3.6,3.2C183.56,425.371,183.56,427.691,183.73,427.672Z",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9297",
    "data-name": "Group 9297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9296",
    "data-name": "Group 9296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9295",
    "data-name": "Group 9295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9294",
    "data-name": "Group 9294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9293",
    "data-name": "Group 9293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9292",
    "data-name": "Group 9292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9291",
    "data-name": "Group 9291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9290",
    "data-name": "Group 9290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9289",
    "data-name": "Group 9289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9288",
    "data-name": "Group 9288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9287",
    "data-name": "Group 9287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6128",
    "data-name": "Path 6128",
    d: "M184.286,421.365c.031-.032-.262-.416-.945-.95a9.3,9.3,0,0,0-3.286-1.618,4.12,4.12,0,0,0-2.645-.054,1.457,1.457,0,0,0-.885,1.421,2.372,2.372,0,0,0,.784,1.5,5.125,5.125,0,0,0,6.53-.04,5.945,5.945,0,0,0,1.719-6.387,2.065,2.065,0,0,0-1.186-1.243,1.431,1.431,0,0,0-1.575.575,5.063,5.063,0,0,0-.707,2.53,10.369,10.369,0,0,0,.357,3.641,3.152,3.152,0,0,0,.521,1.232,16.524,16.524,0,0,1-.332-4.819,4.739,4.739,0,0,1,.671-2.19.764.764,0,0,1,.856-.319,1.419,1.419,0,0,1,.732.863,5.306,5.306,0,0,1-1.554,5.52,4.448,4.448,0,0,1-5.543.114,1.717,1.717,0,0,1-.591-1.024.788.788,0,0,1,.477-.791,3.726,3.726,0,0,1,2.241.005A13.743,13.743,0,0,1,184.286,421.365Z",
    fill: "#fff"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9379",
    "data-name": "Group 9379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9301",
    "data-name": "Group 9301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6129",
    "data-name": "Path 6129",
    d: "M122.313,432.121c.074.009.188,24.427.188,24.427s16.929,2.655,16.929,2.222,5-23.769,5-23.769Z",
    fill: "#c17560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9378",
    "data-name": "Group 9378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9377",
    "data-name": "Group 9377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9311",
    "data-name": "Group 9311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9310",
    "data-name": "Group 9310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9309",
    "data-name": "Group 9309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9308",
    "data-name": "Group 9308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9307",
    "data-name": "Group 9307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9306",
    "data-name": "Group 9306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9305",
    "data-name": "Group 9305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9304",
    "data-name": "Group 9304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9303",
    "data-name": "Group 9303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9302",
    "data-name": "Group 9302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6130",
    "data-name": "Path 6130",
    d: "M140.8,451.985s-12.31,9.271-18.338.91l-.238,2.23-11.077,26.32c-1.648,4.355.324,6.753,2.038,7.511a3.619,3.619,0,0,0,3.862-.57c5.635-4.92,26.274-23.124,26.191-25.716l.111-2.385c.388-3.5-.829-6.665-2.132-7.238Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9321",
    "data-name": "Group 9321",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9320",
    "data-name": "Group 9320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9319",
    "data-name": "Group 9319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9318",
    "data-name": "Group 9318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9317",
    "data-name": "Group 9317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9316",
    "data-name": "Group 9316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9315",
    "data-name": "Group 9315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9314",
    "data-name": "Group 9314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9313",
    "data-name": "Group 9313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9312",
    "data-name": "Group 9312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6131",
    "data-name": "Path 6131",
    d: "M113.826,489.172l29.526-28.887-.07,1.5c.072,1.63-.664,2.241-1.479,3.248-2.416,2.984-9.035,9.608-24.646,23.363a3.622,3.622,0,0,1-3.331.779Z",
    fill: "#fff"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9332",
    "data-name": "Group 9332",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9331",
    "data-name": "Group 9331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9330",
    "data-name": "Group 9330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9329",
    "data-name": "Group 9329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9328",
    "data-name": "Group 9328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9327",
    "data-name": "Group 9327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9326",
    "data-name": "Group 9326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9325",
    "data-name": "Group 9325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9324",
    "data-name": "Group 9324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9323",
    "data-name": "Group 9323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9322",
    "data-name": "Group 9322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6132",
    "data-name": "Path 6132",
    d: "M138.115,457.581a2.194,2.194,0,0,0-.733,2.833,2.108,2.108,0,0,0,2.8.752,2.313,2.313,0,0,0,.761-3,2.187,2.187,0,0,0-3-.459",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9343",
    "data-name": "Group 9343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9342",
    "data-name": "Group 9342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9341",
    "data-name": "Group 9341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9340",
    "data-name": "Group 9340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9339",
    "data-name": "Group 9339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9338",
    "data-name": "Group 9338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9337",
    "data-name": "Group 9337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9336",
    "data-name": "Group 9336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9335",
    "data-name": "Group 9335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9334",
    "data-name": "Group 9334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9333",
    "data-name": "Group 9333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6133",
    "data-name": "Path 6133",
    d: "M124.28,470.7c-.2.088-.915-1.8-2.97-2.894-2.023-1.155-4-.748-4.033-.968-.027-.088.434-.342,1.266-.42a5.78,5.78,0,0,1,5.417,2.987C124.338,470.156,124.369,470.681,124.28,470.7Z",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9354",
    "data-name": "Group 9354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9353",
    "data-name": "Group 9353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9352",
    "data-name": "Group 9352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9351",
    "data-name": "Group 9351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9350",
    "data-name": "Group 9350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9349",
    "data-name": "Group 9349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9348",
    "data-name": "Group 9348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9347",
    "data-name": "Group 9347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9346",
    "data-name": "Group 9346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9345",
    "data-name": "Group 9345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9344",
    "data-name": "Group 9344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6134",
    "data-name": "Path 6134",
    d: "M121.465,474.639c-.175.145-1.256-1.057-3.059-1.666-1.791-.649-3.384-.384-3.431-.606-.094-.185,1.642-.856,3.688-.127C120.714,472.946,121.653,474.552,121.465,474.639Z",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9365",
    "data-name": "Group 9365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9364",
    "data-name": "Group 9364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9363",
    "data-name": "Group 9363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9362",
    "data-name": "Group 9362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9361",
    "data-name": "Group 9361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9360",
    "data-name": "Group 9360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9359",
    "data-name": "Group 9359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9358",
    "data-name": "Group 9358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9357",
    "data-name": "Group 9357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9356",
    "data-name": "Group 9356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9355",
    "data-name": "Group 9355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6135",
    "data-name": "Path 6135",
    d: "M127.5,466.287c-.151.139-1.584-1.471-3.944-2.506-2.345-1.071-4.5-1.067-4.5-1.272-.042-.166,2.255-.485,4.772.657C126.356,464.282,127.649,466.208,127.5,466.287Z",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9376",
    "data-name": "Group 9376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9375",
    "data-name": "Group 9375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9374",
    "data-name": "Group 9374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9373",
    "data-name": "Group 9373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9372",
    "data-name": "Group 9372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9371",
    "data-name": "Group 9371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9370",
    "data-name": "Group 9370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9369",
    "data-name": "Group 9369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9368",
    "data-name": "Group 9368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9367",
    "data-name": "Group 9367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9366",
    "data-name": "Group 9366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6136",
    "data-name": "Path 6136",
    d: "M123.522,461.359a3.061,3.061,0,0,1,.255-1.314,9.3,9.3,0,0,1,1.828-3.175,4.119,4.119,0,0,1,2.166-1.518,1.455,1.455,0,0,1,1.527.687,2.373,2.373,0,0,1,.185,1.682,5.126,5.126,0,0,1-5.446,3.6,5.945,5.945,0,0,1-4.985-4.347,2.061,2.061,0,0,1,.293-1.693,1.429,1.429,0,0,1,1.627-.4,5.057,5.057,0,0,1,2,1.707,10.367,10.367,0,0,1,1.732,3.223,3.169,3.169,0,0,1,.254,1.314,16.512,16.512,0,0,0-2.409-4.187,4.737,4.737,0,0,0-1.777-1.445.763.763,0,0,0-.889.212,1.417,1.417,0,0,0-.127,1.124,5.306,5.306,0,0,0,4.366,3.719,4.449,4.449,0,0,0,4.666-2.994,1.718,1.718,0,0,0-.079-1.179.791.791,0,0,0-.837-.392,3.726,3.726,0,0,0-1.858,1.252A13.748,13.748,0,0,0,123.522,461.359Z",
    fill: "#fff"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9385",
    "data-name": "Group 9385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9380",
    "data-name": "Group 9380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6137",
    "data-name": "Path 6137",
    d: "M100.148,238.844l21.111-8.125s5.322,9.19,14.7,8.388c9.592-.82,9.289-7.817,9.289-7.817l26.53,7.528s1.748,35.872,0,41.477-6.721,12.891-6.721,12.891,5.242,12.191,5.377,15.554-1.344,2.522-1.344,2.522l-64.009.768Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9382",
    "data-name": "Group 9382",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9381",
    "data-name": "Group 9381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6138",
    "data-name": "Path 6138",
    d: "M156.446,275.6c-.819-.74-2.111-.244-3.082.281-5.517,2.98-11.043,5.965-16.277,9.418-6.6,4.354-12.7,9.426-19.165,13.984q-5.715,4.029-11.791,7.509l-1.376,2.394c1.456,2.37,4.471,3.441,7.244,3.223a17.264,17.264,0,0,0,7.692-3.008c10.865-6.878,18.515-18.009,29.381-24.886,2.688-1.7,5.68-3.249,7.31-5.981C156.926,277.62,157.234,276.311,156.446,275.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9384",
    "data-name": "Group 9384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9383",
    "data-name": "Group 9383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6139",
    "data-name": "Path 6139",
    d: "M158.922,292.586a15.514,15.514,0,0,1-2.639.141c-1.627.043-3.871.124-6.344.308s-4.706.441-6.321.641a15.542,15.542,0,0,1-2.629.255,11.659,11.659,0,0,1,2.574-.619,63.651,63.651,0,0,1,12.721-.953A11.675,11.675,0,0,1,158.922,292.586Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9393",
    "data-name": "Group 9393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9386",
    "data-name": "Group 9386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6140",
    "data-name": "Path 6140",
    d: "M90.542,282.292s5.911,16.678,8.529,20.929,3.736,9.731,12.126,7.494,12.65-7.7,21.823-15.227,15.091-13.2,15.091-13.2l-6.459-7.82-26.764,12.193-6.376-13.982Z",
    fill: "#c17560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9387",
    "data-name": "Group 9387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6141",
    "data-name": "Path 6141",
    d: "M171.468,257.249l-18.392,9.7-15.049,9.586s7.477,6.617,9.583,6.455,4.971-3.08,4.971-3.08a2.191,2.191,0,0,0,1.242,1.189c.919.324,2-.757,2-.757a6.444,6.444,0,0,0,2,.433c.918,0,1.987-3.523,2.528-5.846a4.135,4.135,0,0,0-.367-3.447l.718-.414,1.014,1.774-1.57,5.61c-.832,3.078,2.143,2.66,2.143,2.66s3.273-5.691,3.608-8.924-2.9-5.3-2.9-5.3,6.8-5.852,8.471-6.967S171.468,257.249,171.468,257.249Z",
    fill: "#c17560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9389",
    "data-name": "Group 9389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9388",
    "data-name": "Group 9388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6142",
    "data-name": "Path 6142",
    d: "M112.673,298.915a4.749,4.749,0,0,1-.6-1.842,12.2,12.2,0,0,1,1.917-8.991,4.762,4.762,0,0,1,1.3-1.436,15.234,15.234,0,0,0-2.615,12.269Z",
    fill: "#6f4439"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9390",
    "data-name": "Group 9390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6143",
    "data-name": "Path 6143",
    d: "M101.235,238.419s-11.82,3.491-14.105,15.962c-1.362,7.433,1.928,31.566,1.928,31.566l22.848-8.5Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9392",
    "data-name": "Group 9392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9391",
    "data-name": "Group 9391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6144",
    "data-name": "Path 6144",
    d: "M105.077,255a24.652,24.652,0,0,1,.906,3.364c.536,2.23,1.213,5.048,1.961,8.164.778,3.186,1.516,6.059,2.092,8.127s.982,3.331.908,3.359a3.2,3.2,0,0,1-.4-.848c-.236-.557-.518-1.382-.858-2.4-.669-2.049-1.466-4.917-2.245-8.109s-1.4-6.1-1.814-8.209A21.6,21.6,0,0,1,105.077,255Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9409",
    "data-name": "Group 9409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9394",
    "data-name": "Group 9394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6145",
    "data-name": "Path 6145",
    d: "M105.771,312.03s-15.1,17.7-14.741,31.992a53.719,53.719,0,0,0,6.738,24.621l20.017,1.176s1.779-9.545,8.937-9.545c1.55,0,27.649,49.992,27.649,49.992l25.569-11.688s-16.816-44.174-20.93-54.556-7.97-15.392-13.466-16.876l-6.125-15.5Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9396",
    "data-name": "Group 9396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9395",
    "data-name": "Group 9395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6146",
    "data-name": "Path 6146",
    d: "M110,329.139c-.024.088-.944-.167-2.457-.285a14.873,14.873,0,0,0-5.82.691,12.826,12.826,0,0,0-4.977,3.043c-1.064,1.076-1.568,1.891-1.651,1.837-.03-.019.075-.233.293-.609a9.313,9.313,0,0,1,1.091-1.482,11.84,11.84,0,0,1,5.079-3.283,13.428,13.428,0,0,1,6.023-.563A6.791,6.791,0,0,1,110,329.139Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9398",
    "data-name": "Group 9398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9397",
    "data-name": "Group 9397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6147",
    "data-name": "Path 6147",
    d: "M134.477,325.422a45.4,45.4,0,0,1-.26-6.859,45.387,45.387,0,0,1,.26-6.859,45.391,45.391,0,0,1,.26,6.859A45.4,45.4,0,0,1,134.477,325.422Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9400",
    "data-name": "Group 9400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9399",
    "data-name": "Group 9399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6148",
    "data-name": "Path 6148",
    d: "M116.842,311.648a2.4,2.4,0,0,1-.265.8,12.816,12.816,0,0,1-1.1,2.013,15.18,15.18,0,0,1-12.945,6.782,12.73,12.73,0,0,1-2.283-.239,2.4,2.4,0,0,1-.808-.238c.015-.091,1.187.158,3.09.109a15.993,15.993,0,0,0,12.644-6.625C116.295,312.715,116.758,311.609,116.842,311.648Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9401",
    "data-name": "Group 9401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6149",
    "data-name": "Path 6149",
    d: "M169.632,311.262a41.348,41.348,0,0,1,10.308,20.573c2.072,12.391,2.2,28.557-1.33,34.537l-10.1,2.271-8.888,9.011L147.034,446.2l-28.588-3.925s-2.676-59.557-1.756-65.23,1.1-7.222,1.1-7.222-.635-9.339,6.112-16.086a166.436,166.436,0,0,1,16.407-13.8l-.885-28.285Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9403",
    "data-name": "Group 9403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9402",
    "data-name": "Group 9402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6150",
    "data-name": "Path 6150",
    d: "M175.875,320.987a3.759,3.759,0,0,1-.932.394,15.646,15.646,0,0,1-11.612-.845,11.926,11.926,0,0,1-2.16-1.486c-.644-.536-1.245-1.079-1.8-1.614a38.17,38.17,0,0,1-2.767-3c-.743-.891-1.316-1.632-1.705-2.149a3.791,3.791,0,0,1-.561-.84,32.492,32.492,0,0,1,2.544,2.747c.775.854,1.709,1.858,2.82,2.894a19.851,19.851,0,0,0,3.871,2.988,15.743,15.743,0,0,0,8.634,1.542C174.494,321.41,175.846,320.885,175.875,320.987Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9405",
    "data-name": "Group 9405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9404",
    "data-name": "Group 9404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6151",
    "data-name": "Path 6151",
    d: "M117.785,369.819s.041-.329.156-.967a6.585,6.585,0,0,1,.278-1.175,9.143,9.143,0,0,1,.581-1.567,9.678,9.678,0,0,1,2.843-3.685,11.318,11.318,0,0,1,5.875-2.383l.079-.008.042.077,26.947,50.04-.316-.106,25.563-11.7-.134.33c-1.306-3.331-2.693-6.866-4.1-10.443-4.845-12.373-9.492-24.237-13.784-35.2-2.141-5.48-4.2-10.734-6.14-15.712a16.129,16.129,0,0,0-4.188-6.356,14.557,14.557,0,0,0-6.234-3.423l-.018-.005a52.316,52.316,0,0,0-16.88-2.01,53.192,53.192,0,0,0-12.765,2.116,54.981,54.981,0,0,0-7.7,2.919c-.855.4-1.49.748-1.928.959s-.666.314-.666.314.212-.133.638-.367,1.055-.593,1.9-1.012a51.933,51.933,0,0,1,7.687-3.031,52.954,52.954,0,0,1,29.823-.276l-.018,0a14.908,14.908,0,0,1,6.447,3.5,16.546,16.546,0,0,1,4.319,6.507c1.957,4.973,4.021,10.223,6.175,15.7l13.813,35.186c1.4,3.578,2.788,7.113,4.094,10.444l.089.229-.223.1-25.575,11.675-.209.1-.107-.2-26.746-50.148.12.068a11.151,11.151,0,0,0-5.764,2.28,9.62,9.62,0,0,0-2.844,3.587,9.325,9.325,0,0,0-.606,1.539,7.013,7.013,0,0,0-.308,1.159C117.873,369.5,117.785,369.819,117.785,369.819Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9407",
    "data-name": "Group 9407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9406",
    "data-name": "Group 9406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6152",
    "data-name": "Path 6152",
    d: "M175.875,332.825c-.056.085-1.154-.694-3.125-1.536a21.1,21.1,0,0,0-3.571-1.146,21.384,21.384,0,0,0-9.117-.057,21.128,21.128,0,0,0-3.585,1.1c-1.981.817-3.088,1.582-3.143,1.5a3.3,3.3,0,0,1,.745-.581,7.705,7.705,0,0,1,.943-.584,12.835,12.835,0,0,1,1.309-.669,18.955,18.955,0,0,1,3.628-1.233,20.233,20.233,0,0,1,9.329.058,18.907,18.907,0,0,1,3.612,1.277,12.946,12.946,0,0,1,1.3.686,7.586,7.586,0,0,1,.935.6A3.232,3.232,0,0,1,175.875,332.825Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9408",
    "data-name": "Group 9408",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6153",
    "data-name": "Path 6153",
    d: "M127.525,360.172s7.562,32.332,15.816,41.38S153.8,412.505,153.8,412.505l.567-2.239Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9423",
    "data-name": "Group 9423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9410",
    "data-name": "Group 9410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6154",
    "data-name": "Path 6154",
    d: "M172.152,303.525s.831-5.043,3.283-7.891a55.384,55.384,0,0,1,6.961-6.249h1.266l3.322-7.441,9.326-.45s-1.97,18.174-6.479,23.711-9.062,5.233-10.96,4.68S172.152,303.525,172.152,303.525Z",
    fill: "#c17560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9414",
    "data-name": "Group 9414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9411",
    "data-name": "Group 9411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6155",
    "data-name": "Path 6155",
    d: "M156.065,233.306,148.7,269.638a3.227,3.227,0,0,0,3.164,3.868h50.657a3.227,3.227,0,0,0,3.15-2.522l8.141-36.331a3.228,3.228,0,0,0-3.149-3.934H159.229A3.228,3.228,0,0,0,156.065,233.306Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9413",
    "data-name": "Group 9413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9412",
    "data-name": "Group 9412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6156",
    "data-name": "Path 6156",
    d: "M156.066,233.306a1.873,1.873,0,0,1,.116-.5,3.163,3.163,0,0,1,.808-1.257,3.289,3.289,0,0,1,2.236-.91l3.307-.024,21.075-.083,14.553-.032,8.108-.013,4.24-.006a3.5,3.5,0,0,1,3.5,2.539,4.246,4.246,0,0,1-.092,2.3l-.489,2.192-1,4.459q-1.008,4.508-2.054,9.2c-1.4,6.246-2.846,12.713-4.328,19.337a5.613,5.613,0,0,1-.378,1.271,3.389,3.389,0,0,1-.816,1.089,3.523,3.523,0,0,1-2.49.894h-4.995l-9.765,0-18.461-.016-16.705-.024a4.26,4.26,0,0,1-1.991-.312,3.445,3.445,0,0,1-1.5-1.328,3.375,3.375,0,0,1-.505-1.9,14.576,14.576,0,0,1,.322-1.844q.73-3.567,1.4-6.841l4.266-20.637c.511-2.417.91-4.3,1.185-5.606.138-.623.245-1.106.322-1.455.075-.327.127-.492.127-.492s-.017.172-.075.5l-.271,1.465c-.253,1.309-.62,3.2-1.09,5.625-.973,4.9-2.374,11.959-4.1,20.67q-.655,3.273-1.371,6.848a15.193,15.193,0,0,0-.306,1.776,2.961,2.961,0,0,0,.451,1.669,3.027,3.027,0,0,0,1.321,1.161,3.829,3.829,0,0,0,1.816.268l16.705-.025,18.461-.015,9.765,0h4.995a3,3,0,0,0,2.143-.761,2.9,2.9,0,0,0,.693-.926,5.124,5.124,0,0,0,.34-1.161c1.486-6.623,2.936-13.089,4.338-19.335q1.053-4.683,2.066-9.194.507-2.252,1-4.457.249-1.1.494-2.191a3.768,3.768,0,0,0,.1-2.07,3.019,3.019,0,0,0-3.035-2.2l-4.24-.006-8.108-.013-14.553-.032-21.075-.083-3.306-.023a3.19,3.19,0,0,0-2.165.832A3.508,3.508,0,0,0,156.066,233.306Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9415",
    "data-name": "Group 9415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6157",
    "data-name": "Path 6157",
    d: "M186.228,249.867s6.113,10.4,6.743,11.785,2.458,3.5,2.584,4.8,1.575,8.807,1.449,11.517a20.39,20.39,0,0,1-1.627,6.054l-8.393-2.084a13.5,13.5,0,0,1-3.134-4.285,9.689,9.689,0,0,0-3.231-4.348c-1.071-.82-5.293-3.474-5.794-4.429a2.047,2.047,0,0,1,0-2.047s-1.953-.942-2.273-2.032c-.34-1.162,0-2.71,2.206-1.7s10.335,6.807,11.155,6.176-.19-2.154-.19-2.154-8.633-7.866-9.074-9.252.819-3.34,2.835-1.639,8.634,8.382,9.327,8.382-.063-1.954-.063-1.954-3.4-7.31-3.967-9.264S184.526,248.859,186.228,249.867Z",
    fill: "#c17560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9417",
    "data-name": "Group 9417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9416",
    "data-name": "Group 9416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6158",
    "data-name": "Path 6158",
    d: "M214.2,232.86a.88.88,0,0,1-.247.027l-.724.026-2.786.049-10.247.082-33.8.077H161.5a2.574,2.574,0,0,0-2.022.669,2.249,2.249,0,0,0-.571.884c-.106.317-.179.745-.269,1.11-.691,3.033-1.329,5.966-1.926,8.763-1.177,5.588-2.238,10.624-3.133,14.871-.9,4.231-1.678,7.647-2.241,10q-.422,1.715-.666,2.706c-.076.283-.137.513-.188.7a.887.887,0,0,1-.081.235.851.851,0,0,1,.03-.247c.036-.19.081-.424.137-.712l.571-2.726c.5-2.413,1.207-5.828,2.078-10.031.863-4.254,1.887-9.3,3.024-14.9.584-2.8,1.213-5.738,1.9-8.777.1-.39.146-.738.283-1.167a2.754,2.754,0,0,1,.7-1.085,3.1,3.1,0,0,1,2.378-.817h4.89l33.8.076,10.247.083,2.786.049.724.026A.912.912,0,0,1,214.2,232.86Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9419",
    "data-name": "Group 9419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9418",
    "data-name": "Group 9418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6159",
    "data-name": "Path 6159",
    d: "M173.368,296.907a2.631,2.631,0,0,1,.26-.815,10.894,10.894,0,0,1,1.17-2.02,11.575,11.575,0,0,1,6.269-4.341,10.984,10.984,0,0,1,2.3-.347l-.2.117c1.14-2.081,2.02-4.057,2.7-5.4a17.4,17.4,0,0,1,1.125-2.156,10.233,10.233,0,0,1-.825,2.292c-.609,1.4-1.395,3.346-2.571,5.54l-.057.106-.148.011a10.932,10.932,0,0,0-2.182.342,11.909,11.909,0,0,0-6.111,4.062C173.886,295.8,173.457,296.95,173.368,296.907Z",
    fill: "#6f4439"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9421",
    "data-name": "Group 9421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9420",
    "data-name": "Group 9420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6160",
    "data-name": "Path 6160",
    d: "M184.238,272.443a28.869,28.869,0,0,1-4.8-2.622,28.877,28.877,0,0,1-4.534-3.068,29.091,29.091,0,0,1,4.805,2.623A28.913,28.913,0,0,1,184.238,272.443Z",
    fill: "#6f4439"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9422",
    "data-name": "Group 9422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6161",
    "data-name": "Path 6161",
    d: "M186.945,241.629a1.67,1.67,0,1,1-1.035-2.274A1.773,1.773,0,0,1,186.945,241.629Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9426",
    "data-name": "Group 9426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9425",
    "data-name": "Group 9425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6162",
    "data-name": "Path 6162",
    d: "M111.994,201.838a2.762,2.762,0,0,1-.553-1.01,5.993,5.993,0,0,1-.244-3.138,5.818,5.818,0,0,1,2.618-3.839,6.1,6.1,0,0,1,2.645-.946,4.2,4.2,0,0,1,1.527.071,1.611,1.611,0,0,1,1.2,1.169,1.189,1.189,0,0,1-.185.907,1.753,1.753,0,0,1-.643.564,2.472,2.472,0,0,1-1.564.223,2.893,2.893,0,0,1-2.049-4.336,3.358,3.358,0,0,1,1.655-1.509,3.674,3.674,0,0,1,3.123.247,2.169,2.169,0,0,1,.879.748c-.032.037-.32-.264-.97-.568a3.581,3.581,0,0,0-2.889-.088,3.008,3.008,0,0,0-1.415,1.371,2.6,2.6,0,0,0-.131,2.183,2.552,2.552,0,0,0,1.882,1.449,1.976,1.976,0,0,0,1.235-.177.889.889,0,0,0,.562-.91,1.1,1.1,0,0,0-.835-.774,3.747,3.747,0,0,0-1.332-.062,5.694,5.694,0,0,0-2.442.843,5.521,5.521,0,0,0-2.514,3.509,6.243,6.243,0,0,0,.076,3C111.835,201.458,112.034,201.816,111.994,201.838Z",
    fill: "#263238"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginHero);
export default __webpack_public_path__ + "static/media/loginHero.abea8ff72af56127eaf946e9639e1539.svg";
export { ForwardRef as ReactComponent };